export type CameraType = "Dome" | "Tubular" | "Fisheye" | "PTZ" | "Pinhole" | "PTRZ";
export type Brand = "DAHUA" | "TVT";
export type LensType = "Fixa" | "Motorizada";
export type WdrType = "WDR" | "DWDR";

export interface Camera {
  id: string;
  brand: Brand;
  model: string;
  fullName: string;
  ref: string;
  price: string;
  link: string;
  image?: string;
  type: CameraType;
  megapixels: number;
  lensFixed?: string;
  lensMotorized?: string;
  lensType: LensType;
  irRange: number;
  wdrType?: WdrType;
  hasWifi: boolean;
  has4G: boolean;
  hasSolar: boolean;
  hasAudio: boolean;
  hasSDCard: boolean;
  hasColorNight: boolean;
  hasDualLight: boolean;
  hasAI: boolean;
  hasIK10: boolean;
  hasPOE: boolean;
  detPeople: boolean;
  detVehicle: boolean;
  hasLPR: boolean;
  color?: "Branco" | "Preto";
  equivalent?: string[];
}

export const cameras: Camera[] = [
  {
    id: "tvt-VDTV-00213",
    brand: "TVT",
    model: "9540S5L-D(D/PN/AW2)",
    fullName: "9540S5L-D(D/PN/AW2) DOME TURRET IPC 4MP 2.8mm DUAL 10/20M TV",
    ref: "VDTV-00213",
    price: "49,41 €",
    link: "https://conteragroup.pt/camaras-td-ipc-domes/12985-9540s5l-dd-pn-aw2-turret-ipc-4mp-28mm-dual-10-20m-20.html",
    image: "https://conteragroup.pt/4393-medium_default/9540s5l-dd-pn-aw2-turret-ipc-4mp-28mm-dual-10-20m.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 20,
    wdrType: "DWDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: false,
    hasIK10: false,
    hasPOE: false,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00212",
    brand: "TVT",
    model: "9440S5L-D(D/PN/AW2)",
    fullName: "9440S5L-D(D/PN/AW2) TUBULAR IPC 4MP 2.8mm 10/20M DUAL",
    ref: "VDTV-00212",
    price: "49,41 €",
    link: "https://conteragroup.pt/camaras-td-ipc-tubulares/12984-9440s5l-dd-pn-aw2-tubular-ipc-4mp-28mm-dual-10-20m-6977749350144.html",
    image: "https://conteragroup.pt/4392-medium_default/9440s5l-dd-pn-aw2-tubular-ipc-4mp-28mm-dual-10-20m.jpg",
    type: "Tubular",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 20,
    wdrType: "DWDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: false,
    hasIK10: false,
    hasPOE: false,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00163",
    brand: "TVT",
    model: "9442S4L-C(D/AZ/PE/AW3)",
    fullName: "9442S4L-C(D/AZ/PE/AW3) TUBULAR IPC 4MP MTZ 30/50M DUAL TVT",
    ref: "VDTV-00163",
    price: "134,31 €",
    link: "https://conteragroup.pt/camaras-td-ipc-tubulares/11650-9442s4l-cdazpeaw3-tubular-ipc-4mp-mtz-dual-3050m-6977749350861.html",
    image: "https://conteragroup.pt/3128-medium_default/9442s4l-cdazpeaw3-tubular-ipc-4mp-mtz-dual-3050m.jpg",
    type: "Tubular",
    megapixels: 4,
    lensMotorized: "2.8-12mm",
    lensType: "Motorizada",
    irRange: 50,
    wdrType: "DWDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00165",
    brand: "TVT",
    model: "9545S4L-C(D/AZ/PE/AW3)",
    fullName: "9545S4L-C(D/AZ/PE/AW3) DOME TURRET IPC 4MP MTZ DUAL 30/50M",
    ref: "VDTV-00165",
    price: "134,31 €",
    link: "https://conteragroup.pt/camaras-td-ipc-domes/11652-9545s4l-cdazpeaw3-turret-ipc-4mp-mtz-dual-3050m-5600947297713.html",
    image: "https://conteragroup.pt/4561-medium_default/9545s4l-cdazpeaw3-turret-ipc-4mp-mtz-dual-3050m.jpg",
    type: "Dome",
    megapixels: 4,
    lensMotorized: "2.8-12mm",
    lensType: "Motorizada",
    irRange: 50,
    wdrType: "DWDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00173",
    brand: "TVT",
    model: "9482S4-C(D/AZ/PE/AW3)",
    fullName: "9482S4-C(D/AZ/PE/AW3) TUBULAR IPC 8MP MTZ WDR DUAL 30/50M",
    ref: "VDTV-00173",
    price: "287,99 €",
    link: "https://conteragroup.pt/camaras-td-ipc-tubulares/12053-9482s4-cd-az-pe-aw3-tubular-ipc-8mp-mtz-wdr-dual-30-50m-5600947297522.html",
    image: "https://conteragroup.pt/3307-medium_default/9482s4-cd-az-pe-aw3-tubular-ipc-8mp-mtz-wdr-dual-30-50m.jpg",
    type: "Tubular",
    megapixels: 8,
    lensMotorized: "2.8-12mm",
    lensType: "Motorizada",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00174",
    brand: "TVT",
    model: "9585S4-C(D/AZ/PE/AW3)",
    fullName: "9585S4-C(D/AZ/PE/AW3) TURRET IPC 8MP MTZ WDR DUAL 30/50M",
    ref: "VDTV-00174",
    price: "287,99 €",
    link: "https://conteragroup.pt/camaras-td-ipc-domes/12054-9585s4-cd-az-pe-aw3-turret-ipc-8mp-mtz-wdr-dual-30-50m-5600947297539.html",
    image: "https://conteragroup.pt/3312-medium_default/9585s4-cd-az-pe-aw3-turret-ipc-8mp-mtz-wdr-dual-30-50m.jpg",
    type: "Dome",
    megapixels: 8,
    lensMotorized: "2.8-12mm",
    lensType: "Motorizada",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00257",
    brand: "TVT",
    model: "9442E4(D/PE/AW3)",
    fullName: "9442E4(D/PE/AW3) TUBULAR IPC 4MP 2.8mm DUAL 40/50M !DA",
    ref: "VDTV-00257",
    price: "210,00 €",
    link: "https://conteragroup.pt/camaras-td-ipc-tubulares/13455-9442e4d-pe-aw3-tubular-ipc-4mp-28mm-ik10-dual-40-50m-da-6977749352780.html",
    image: "https://conteragroup.pt/4948-medium_default/9442e4d-pe-aw3-tubular-ipc-4mp-28mm-ik10-dual-40-50m-da.jpg",
    type: "Tubular",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00170",
    brand: "TVT",
    model: "9544S4-C(D/PE/AW2)",
    fullName: "9544S4-C(D/PE/AW2) DOME TURRET IPC 4MP 2.8mm WDR DUAL 20/30M",
    ref: "VDTV-00170",
    price: "135,03 €",
    link: "https://conteragroup.pt/camaras-td-ipc-domes/12050-9544s4-cd-pe-aw2-dome-turret-ipc-4mp-28mm-wdr-dual-20-30m-6977749351691.html",
    image: "https://conteragroup.pt/3314-medium_default/9544s4-cd-pe-aw2-dome-turret-ipc-4mp-28mm-wdr-dual-20-30m.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00228",
    brand: "TVT",
    model: "9581S4-C(D/PE/AW2)",
    fullName: "9581S4-C(D/PE/AW2) DOME IPC 8MP 2.8mm WDR DUAL 20/30M IK10",
    ref: "VDTV-00228",
    price: "220,00 €",
    link: "https://conteragroup.pt/camaras-td-ipc-domes/13183-9581s4-cd-pe-aw2-dome-ipc-8mp-28mm-wdr-dual-20-30m-ik10-6977749352230.html",
    image: "https://conteragroup.pt/4670-medium_default/9581s4-cd-pe-aw2-dome-ipc-8mp-28mm-wdr-dual-20-30m-ik10.jpg",
    type: "Dome",
    megapixels: 8,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: false,
    hasIK10: true,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00258",
    brand: "TVT",
    model: "9443E4-PA(D/AZ/PE/AW5)",
    fullName: "9443E4-PA(D/AZ/PE/AW5) TUBULAR IPC 4MP MTZ IK10 DUAL 50/70M",
    ref: "VDTV-00258",
    price: "355,00 €",
    link: "https://conteragroup.pt/camaras-td-ipc-tubulares/13456-9443e4-pad-az-pe-aw5-tubular-ipc-4mp-mtz-ik10-dual-50-70m-6977749352810.html",
    image: "https://conteragroup.pt/5042-medium_default/9443e4-pad-az-pe-aw5-tubular-ipc-4mp-mtz-ik10-dual-50-70m.jpg",
    type: "Tubular",
    megapixels: 4,
    lensMotorized: "2.7-13.5mm",
    lensType: "Motorizada",
    irRange: 70,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: true,
    hasAI: false,
    hasIK10: true,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00172",
    brand: "TVT",
    model: "9441S4-C(D/PE/AW2)",
    fullName: "9441S4-C(D/PE/AW2) TUBULAR IPC 4MP 2.8mm WDR DUAL 20/30M",
    ref: "VDTV-00172",
    price: "135,03 €",
    link: "https://conteragroup.pt/camaras-td-ipc-tubulares/12052-9441s4-cd-pe-aw2-tubular-ipc-4mp-28mm-wdr-dual-20-30m-5600947297966.html",
    image: "https://conteragroup.pt/4562-medium_default/9441s4-cd-pe-aw2-tubular-ipc-4mp-28mm-wdr-dual-20-30m.jpg",
    type: "Tubular",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00208",
    brand: "TVT",
    model: "9442S4-C(D/AZ/PE/AW3)",
    fullName: "9442S4-C(D/AZ/PE/AW3) TUBULAR IPC 4MP MTZ WDR 40/50M DUAL",
    ref: "VDTV-00208",
    price: "188,00 €",
    link: "https://conteragroup.pt/camaras-td-ipc-tubulares/12816-9442s4-cd-az-pe-aw3-tubular-ipc-4mp-mtz-wdr-dual-40-50m-6977749351561.html",
    image: "https://conteragroup.pt/4208-medium_default/9442s4-cd-az-pe-aw3-tubular-ipc-4mp-mtz-wdr-dual-40-50m.jpg",
    type: "Tubular",
    megapixels: 4,
    lensMotorized: "2.8-12mm",
    lensType: "Motorizada",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00220",
    brand: "TVT",
    model: "9442C2-PA(D/PE/AW3)",
    fullName: "9442C2-PA(D/PE/AW3) TUBULAR IPC 4MP 2.8mm WDR 40M DUAL !DA",
    ref: "VDTV-00220",
    price: "228,00 €",
    link: "https://conteragroup.pt/camaras-td-ipc-tubulares/13104-9442c2-pad-pe-aw3-tubular-ipc-4mp-28mm-wdr-dual-40m-da.html",
    image: "https://conteragroup.pt/4554-medium_default/9442c2-pad-pe-aw3-tubular-ipc-4mp-28mm-wdr-dual-40m-da.jpg",
    type: "Tubular",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 40,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00028",
    brand: "TVT",
    model: "9525S4H(D/AZ/PE/AR3)",
    fullName: "9525S4H(D/AZ/PE/AR3) DOME TURRET IPC 2MP MTZ WDR IR50M MIC",
    ref: "VDTV-00028",
    price: "178,81 €",
    link: "https://conteragroup.pt/camaras-td-ipc-domes/11452-9525s4hdazpear3-dome-turret-ipc-2mp-mtz28-12-ir50m-mic-5600341670198.html",
    image: "https://conteragroup.pt/4571-medium_default/9525s4hdazpear3-dome-turret-ipc-2mp-mtz28-12-ir50m-mic.jpg",
    type: "Dome",
    megapixels: 2,
    lensMotorized: "2.8-12mm",
    lensType: "Motorizada",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00225",
    brand: "TVT",
    model: "9481S4-C(D/PE/AW2)",
    fullName: "9481S4-C(D/PE/AW2) TUBULAR IPC 8MP 2.8mm WDR DUAL 30/30M",
    ref: "VDTV-00225",
    price: "200,00 €",
    link: "https://conteragroup.pt/camaras-td-ipc-tubulares/13180-9481s4-cd-pe-aw2-tubular-ipc-8mp-28mm-wdr-dual-30-30m-6977749352100.html",
    image: "https://conteragroup.pt/4667-medium_default/9481s4-cd-pe-aw2-tubular-ipc-8mp-28mm-wdr-dual-30-30m.jpg",
    type: "Tubular",
    megapixels: 8,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00023",
    brand: "TVT",
    model: "9421S4(D/PE/AR2)",
    fullName: "9421S4(D/PE/AR2) TUBULAR IPC 2MP 2.8mm DWDR IR30M IP67 TVT",
    ref: "VDTV-00023",
    price: "90,23 €",
    link: "https://conteragroup.pt/camaras-td-ipc-tubulares/11447-9421s4dpear2-tubular-ipc-2mp-28mm-dwdr-ir30m-ip67-tvt-5600341670143.html",
    image: "https://conteragroup.pt/4568-medium_default/9421s4dpear2-tubular-ipc-2mp-28mm-dwdr-ir30m-ip67-tvt.jpg",
    type: "Tubular",
    megapixels: 2,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "DWDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00200",
    brand: "TVT",
    model: "9541S4-C(D/PE/AW2)",
    fullName: "9541S4-C(D/PE/AW2) DOME IPC 4MP 2.8mm WDR IK10 DUAL 20/30M",
    ref: "VDTV-00200",
    price: "128,00 €",
    link: "https://conteragroup.pt/camaras-td-ipc-domes/12808-9541s4-cd-pe-aw2-dome-ipc-4mp-28mm-wdr-ik10-dual-20-30m-5600947298949.html",
    image: "https://conteragroup.pt/4212-medium_default/9541s4-cd-pe-aw2-dome-ipc-4mp-28mm-wdr-ik10-dual-20-30m.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: false,
    hasIK10: true,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00175",
    brand: "TVT",
    model: "9584S4-C(D/PE/AW2)",
    fullName: "9584S4-C(D/PE/AW2) TURRET IPC 8MP 2.8mm WDR DUAL 30/50M",
    ref: "VDTV-00175",
    price: "210,94 €",
    link: "https://conteragroup.pt/camaras-td-ipc-domes/12140-9584s4-cd-pe-aw2-turret-ipc-8mp-28mm-wdr-dual-30-50m-5600947297546.html",
    image: "https://conteragroup.pt/4590-medium_default/9584s4-cd-pe-aw2-turret-ipc-8mp-28mm-wdr-dual-30-50m.jpg",
    type: "Dome",
    megapixels: 8,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 50,
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00036",
    brand: "TVT",
    model: "9553S4(D/AZ/PE/AR3)",
    fullName: "9553S4(D/AZ/PE/AR3) DOME IPC 5MP MTZ 2.8-12mm WDR IR50 IK10",
    ref: "VDTV-00036",
    price: "275,01 €",
    link: "https://conteragroup.pt/camaras-td-ipc-domes/11460-9553s4dazpear3-dome-ipc-5mp-mtz-28-12mm-wdr-ir50-ik10-5600341670426.html",
    image: "https://conteragroup.pt/4573-medium_default/9553s4dazpear3-dome-ipc-5mp-mtz-28-12mm-wdr-ir50-ik10.jpg",
    type: "Dome",
    megapixels: 5,
    lensMotorized: "2.8-12mm",
    lensType: "Motorizada",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: true,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00227",
    brand: "TVT",
    model: "9482E3B-DP(D/PE/AW3)",
    fullName: "9482E3B-DP(D/PE/AW3) TUBULAR IPC 8MP 2x2.8mm/180º DUAL !DA",
    ref: "VDTV-00227",
    price: "140,40 €",
    link: "https://conteragroup.pt/camaras-td-ipc-tubulares/13182-9482e3b-dp-tubular-ipc-8mp-2x28mm-180-1i-o-dual-20-30m-da-6977749353558.html",
    image: "https://conteragroup.pt/4669-medium_default/9482e3b-dp-tubular-ipc-8mp-2x28mm-180-1i-o-dual-20-30m-da.jpg",
    type: "Tubular",
    megapixels: 8,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "DWDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00143",
    brand: "TVT",
    model: "9442C2-PA(D/AZ/PE/AW3)",
    fullName: "9442C2-PA(D/AZ/PE/AW3) TUBULAR IPC 4MP MTZ WDR DUAL 40M !DA",
    ref: "VDTV-00143",
    price: "293,04 €",
    link: "https://conteragroup.pt/camaras-td-ipc-tubulares/11910-9442c2-pad-az-pe-aw3-tubular-ipc-4mp-mtz-wdr-di40m-1i-o-5600341672246.html",
    image: "https://conteragroup.pt/3130-medium_default/9442c2-pad-az-pe-aw3-tubular-ipc-4mp-mtz-wdr-di40m-1i-o.jpg",
    type: "Tubular",
    megapixels: 4,
    lensMotorized: "2.8-12mm",
    lensType: "Motorizada",
    irRange: 40,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00027",
    brand: "TVT",
    model: "9422S4H(D/AZ/PE/AR3)",
    fullName: "9422S4H(D/AZ/PE/AR3) TUBULAR IPC 2MP Mtz 2.8-12mm WDR IR50M",
    ref: "VDTV-00027",
    price: "173,86 €",
    link: "https://conteragroup.pt/camaras-td-ipc-tubulares/11451-9422s4hdazpear3-tubular-ipc-2mp-mtz-28-12mm-wdr-ir50m-5600341670181.html",
    image: "https://conteragroup.pt/4570-medium_default/9422s4hdazpear3-tubular-ipc-2mp-mtz-28-12mm-wdr-ir50m.jpg",
    type: "Tubular",
    megapixels: 2,
    lensMotorized: "2.8-12mm",
    lensType: "Motorizada",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00226",
    brand: "TVT",
    model: "9585E3B-DP",
    fullName: "9585E3B-DP TURRET IPC 8MP 2x2.8mm/180º 1I/O DUAL 20/30M !DA",
    ref: "VDTV-00226",
    price: "360,00 €",
    link: "https://conteragroup.pt/camaras-td-ipc-domes/13181-9585e3b-dp-turret-ipc-8mp-2x28mm-180-1i-o-dual-20-30m-da-6977749353565.html",
    image: "https://conteragroup.pt/4668-medium_default/9585e3b-dp-turret-ipc-8mp-2x28mm-180-1i-o-dual-20-30m-da.jpg",
    type: "Dome",
    megapixels: 8,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "DWDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: true,
    hasAI: false,
    hasIK10: false,
    hasPOE: false,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00108",
    brand: "TVT",
    model: "9443A3BH-A-LR(D/AZ/PE/AR5)",
    fullName: "9443A3BH-A-LR(D/AZ/PE/AR5) LPR TUBULAR IPC 4MP MTZ 2.8-12 TV",
    ref: "VDTV-00108",
    price: "755,61 €",
    link: "https://conteragroup.pt/camaras-td-ipc-tubulares/11900-9443a3bh-lrdaz-pe-ar5-tubular-ipc-4mp-mtz-28-12-1i-o-lpr-5600341672031.html",
    image: "https://conteragroup.pt/3139-medium_default/9443a3bh-lrdaz-pe-ar5-tubular-ipc-4mp-mtz-28-12-1i-o-lpr.jpg",
    type: "Tubular",
    megapixels: 4,
    lensMotorized: "2.8-12mm",
    lensType: "Motorizada",
    irRange: 70,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: true,
  },
  {
    id: "tvt-VDTV-00039",
    brand: "TVT",
    model: "9482S3B(D/PE/AR3)",
    fullName: "9482S3B(D/PE/AR3) TUBULAR IPC 8MP 2.8mm WDR IR50M IP67 TVT",
    ref: "VDTV-00039",
    price: "215,00 €",
    link: "https://conteragroup.pt/camaras-td-ipc-tubulares/11463-9482s3bdpear3-tubular-ipc-8mp-28mm-wdr-ir50m-ip67-tvt-5600341670457.html",
    image: "https://conteragroup.pt/4594-medium_default/9482s3bdpear3-tubular-ipc-8mp-28mm-wdr-ir50m-ip67-tvt.jpg",
    type: "Tubular",
    megapixels: 8,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00224",
    brand: "TVT",
    model: "9565S4-C(D/AZ/PE/AW3)",
    fullName: "9565S4-C(D/AZ/PE/AW3) TURRET IPC 6MP MTZ WDR DUAL 40/50M",
    ref: "VDTV-00224",
    price: "205,00 €",
    link: "https://conteragroup.pt/camaras-td-ipc-domes/13179-9565s4-cd-az-pe-aw3-turret-ipc-6mp-mtz-wdr-dual-40-50m-6977749352063.html",
    image: "https://conteragroup.pt/4666-medium_default/9565s4-cd-az-pe-aw3-turret-ipc-6mp-mtz-wdr-dual-40-50m.jpg",
    type: "Dome",
    megapixels: 6,
    lensMotorized: "2.8-12mm",
    lensType: "Motorizada",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00229",
    brand: "TVT",
    model: "9583E3B-A(D/AZ/PE/AR3)",
    fullName: "9583E3B-A(D/AZ/PE/AR3) DOME IPC 8MP MTZ WDR IR50M 1I/O IK10",
    ref: "VDTV-00229",
    price: "380,00 €",
    link: "https://conteragroup.pt/camaras-td-ipc-domes/13184-9583e3b-ad-az-pe-ar3-dome-ipc-8mp-mtz-wdr-ir50m-1i-o-ik10.html",
    image: "https://conteragroup.pt/4671-medium_default/9583e3b-ad-az-pe-ar3-dome-ipc-8mp-mtz-wdr-ir50m-1i-o-ik10.jpg",
    type: "Dome",
    megapixels: 8,
    lensMotorized: "2.8-12mm",
    lensType: "Motorizada",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: true,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00048",
    brand: "TVT",
    model: "9441S4(D/PE/WF/AR2)",
    fullName: "9441S4(D/PE/WF/AR2) TUBULAR IPC 4MP 2.8mm WDR IR30M WIFI MIC",
    ref: "VDTV-00048",
    price: "132,05 €",
    link: "https://conteragroup.pt/camaras-td-ipc-tubulares/11472-9441s4dpewfar2-tubular-ipc-4mp-28mm-wdr-ir30m-wifi-mic-6977749353602.html",
    image: "https://conteragroup.pt/4574-medium_default/9441s4dpewfar2-tubular-ipc-4mp-28mm-wdr-ir30m-wifi-mic.jpg",
    type: "Tubular",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: true,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00164",
    brand: "TVT",
    model: "9544S4L-C(D/PE/AW1)",
    fullName: "9544S4L-C(D/PE/AW1) DOME TURRET IPC 4MP 2.8mm DUAL 20/30M",
    ref: "VDTV-00164",
    price: "32,74 €",
    link: "https://conteragroup.pt/camaras-td-ipc-domes/11651-9544s4l-cdpeaw1-turret-ipc-4mp-28mm-dual-2030m-5600947297706.html",
    image: "https://conteragroup.pt/3129-medium_default/9544s4l-cdpeaw1-turret-ipc-4mp-28mm-dual-2030m.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "DWDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00026",
    brand: "TVT",
    model: "9521S4(D/PE/AR2)",
    fullName: "9521S4(D/PE/AR2) DOME IPC 2MP 2.8mm DWDR IR30M IP67 IK10 TVT",
    ref: "VDTV-00026",
    price: "96,61 €",
    link: "https://conteragroup.pt/camaras-td-ipc-domes/11450-9521s4dpear2-dome-ipc-2mp-28mm-dwdr-ir30m-ip67-ik10-tvt-5600341670174.html",
    image: "https://conteragroup.pt/4569-medium_default/9521s4dpear2-dome-ipc-2mp-28mm-dwdr-ir30m-ip67-ik10-tvt.jpg",
    type: "Dome",
    megapixels: 2,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "DWDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: true,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00139",
    brand: "TVT",
    model: "9846SP1(D/BA/G4/WR2)",
    fullName: "9846SP1(D/BA/G4/WR2) TUBULAR SOLAR 4MP 2.8mm IR20M 4G C/BAT",
    ref: "VDTV-00139",
    price: "1390,50 €",
    link: "https://conteragroup.pt/camaras-td-ipc-tubulares/12039-9846sp1d-ba-g4-wr2-tubular-solar-4mp-28mm-ir100m-4g-c-bat-5600341672215.html",
    image: "https://conteragroup.pt/3308-medium_default/9846sp1d-ba-g4-wr2-tubular-solar-4mp-28mm-ir100m-4g-c-bat.jpg",
    type: "Tubular",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 20,
    wdrType: "WDR",
    hasWifi: false,
    has4G: true,
    hasSolar: true,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: false,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00106",
    brand: "TVT",
    model: "9545C3H(PE/WR2)",
    fullName: "9545C3H(PE/WR2) TURRET IPC 4MP 2.8mm WDR FColor PRO 1I/O 30",
    ref: "VDTV-00106",
    price: "290,00 €",
    link: "https://conteragroup.pt/camaras-td-ipc-domes/11898-9545c3hpe-wr3-turret-ipc-4mp-28mm-wdr-fcolor-pro-1i-o-40m-5600341671980.html",
    image: "https://conteragroup.pt/4583-medium_default/9545c3hpe-wr3-turret-ipc-4mp-28mm-wdr-fcolor-pro-1i-o-40m.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00118",
    brand: "TVT",
    model: "9523E3B(D/AZ/PE/AR3)",
    fullName: "9523E3B(D/AZ/PE/AR3) DOME IPC 2MP MTZ WDR IR50M 1I/O IK10",
    ref: "VDTV-00118",
    price: "236,69 €",
    link: "https://conteragroup.pt/camaras-td-ipc-domes/12158-9523e3bd-az-pe-ar3-dome-ipc-2mp-mtz-wdr-ir50m-1i-o-ik10-5600341672109.html",
    image: "https://conteragroup.pt/4585-medium_default/9523e3bd-az-pe-ar3-dome-ipc-2mp-mtz-wdr-ir50m-1i-o-ik10.jpg",
    type: "Dome",
    megapixels: 2,
    lensMotorized: "2.8-12mm",
    lensType: "Motorizada",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: true,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00088",
    brand: "TVT",
    model: "C12",
    fullName: "C12 - CUBE IPC 2MP 2.8mm WIFI DWDR IR10M 1xI/O 12V/PoE TVT",
    ref: "VDTV-00088",
    price: "103,10 €",
    link: "https://conteragroup.pt/camaras-td-ipc-consumo/11512-c12---cube-ipc-2mp-28mm-wifi-dwdr-ir10m-1xio-12vpoe-tvt-5600341671492.html",
    image: "https://conteragroup.pt/4582-medium_default/c12---cube-ipc-2mp-28mm-wifi-dwdr-ir10m-1xio-12vpoe-tvt.jpg",
    type: "Dome",
    megapixels: 2,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 10,
    wdrType: "DWDR",
    hasWifi: true,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00218",
    brand: "TVT",
    model: "9825PH1",
    fullName: "9825PH1 PINHOLE+BOX IPC 2MP 2.8mm microSD WDR MIC 8/4 I/O",
    ref: "VDTV-00218",
    price: "240,00 €",
    link: "https://conteragroup.pt/camaras-td-ipc-domes/13103-9825ph1-pinholebox-ipc-2mp-28mm-microsd-wdr-mic-8-4-i-o.html",
    image: "https://conteragroup.pt/4556-medium_default/9825ph1-pinholebox-ipc-2mp-28mm-microsd-wdr-mic-8-4-i-o.jpg",
    type: "Pinhole",
    megapixels: 2,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 0,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: false,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00207",
    brand: "TVT",
    model: "95A8E3B(D/PE/AR1)",
    fullName: "95A8E3B(D/PE/AR1) FISHEYE IPC 12MP 1.65mm DWDR 1I/O IP67 TVT",
    ref: "VDTV-00207",
    price: "506,00 €",
    link: "https://conteragroup.pt/camaras-td-ipc-fisheye/12815-95a8e3bd-pe-ar1-fisheye-ipc-12mp-165mm-dwdr-1i-o-ip67-tvt-6977749353596.html",
    image: "https://conteragroup.pt/4207-medium_default/95a8e3bd-pe-ar1-fisheye-ipc-12mp-165mm-dwdr-1i-o-ip67-tvt.jpg",
    type: "Fisheye",
    megapixels: 12,
    lensFixed: "1.65mm",
    lensType: "Fixa",
    irRange: 20,
    wdrType: "DWDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00035",
    brand: "TVT",
    model: "9551S4(D/PE/AR2)",
    fullName: "9551S4(D/PE/AR2) DOME IPC 5MP 2.8mm WDR IR30M IP67 IK10 MIC",
    ref: "VDTV-00035",
    price: "158,72 €",
    link: "https://conteragroup.pt/camaras-td-ipc-domes/11459-9551s4dpear2-dome-ipc-5mp-28mm-wdr-ir30m-ip67-ik10-mic-5600341670419.html",
    image: "https://conteragroup.pt/4572-medium_default/9551s4dpear2-dome-ipc-5mp-28mm-wdr-ir30m-ip67-ik10-mic.jpg",
    type: "Dome",
    megapixels: 5,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: true,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00113",
    brand: "TVT",
    model: "9421S3B(D/PE/AR2)",
    fullName: "9421S3B(D/PE/AR2) TUBULAR IPC 2MP 2.8mm DWDR IR30M IP67 TVT",
    ref: "VDTV-00113",
    price: "104,75 €",
    link: "https://conteragroup.pt/camaras-td-ipc-tubulares/11529-9431s3bd-pe-ar2-tubular-ipc-2mp-28mm-dwdr-ir30m-ip67-tvt-5600341672079.html",
    image: "https://conteragroup.pt/4584-medium_default/9431s3bd-pe-ar2-tubular-ipc-2mp-28mm-dwdr-ir30m-ip67-tvt.jpg",
    type: "Tubular",
    megapixels: 2,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "DWDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00254",
    brand: "TVT",
    model: "9442C4H(PE/WR2)",
    fullName: "9442C4H(PE/WR2) TUBULAR IPC 4MP 2.8mm WDR FColor PRO 1I/O 30",
    ref: "VDTV-00254",
    price: "290,00 €",
    link: "https://conteragroup.pt/camaras-td-ipc-tubulares/13452-9442c4hpe-wr2-tubular-ipc-4mp-28mm-wdr-fcolor-pro-1i-o-30-6977749352599.html",
    image: "https://conteragroup.pt/4946-medium_default/9442c4hpe-wr2-tubular-ipc-4mp-28mm-wdr-fcolor-pro-1i-o-30.jpg",
    type: "Tubular",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00084",
    brand: "TVT",
    model: "8543IE3N(PE/40M/AR35)",
    fullName: "8543IE3N(PE/40M/AR35) - PTZ IPC 4MP 40X WDR IR350M PoE+IP66",
    ref: "VDTV-00084",
    price: "426,08 €",
    link: "https://conteragroup.pt/camaras-td-ipc-ptz/11508-8543ie3npe40mar35-ptz-ipc-4mp-40x-wdr-ir350m-poe--ip66-6977749356023.html",
    image: "https://conteragroup.pt/2736-medium_default/8543ie3npe40mar35-ptz-ipc-4mp-40x-wdr-ir350m-poe--ip66.jpg",
    type: "PTZ",
    megapixels: 4,
    lensMotorized: "4.5-180mm",
    lensType: "Motorizada",
    irRange: 350,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00144",
    brand: "TVT",
    model: "9545C2-PA(D/AZ/PE/AW3)",
    fullName: "9545C2-PA(D/AZ/PE/AW3) TURRET IPC 4MP MTZ WDR DUAL 40M !DA",
    ref: "VDTV-00144",
    price: "293,04 €",
    link: "https://conteragroup.pt/camaras-td-ipc-domes/12043-9545c2-pad-az-pe-aw3-turret-ipc-4mp-mtz-wdr-di40m-1i-o-5600341672253.html",
    image: "https://conteragroup.pt/3317-medium_default/9545c2-pad-az-pe-aw3-turret-ipc-4mp-mtz-wdr-di40m-1i-o.jpg",
    type: "Dome",
    megapixels: 4,
    lensMotorized: "2.8-12mm",
    lensType: "Motorizada",
    irRange: 40,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00037",
    brand: "TVT",
    model: "9554S4(D/PE/AR2)",
    fullName: "9554S4(D/PE/AR2) DOME TURRET IPC 5MP 2.8mm WDR IR30 MIC TVT",
    ref: "VDTV-00037",
    price: "137,51 €",
    link: "https://conteragroup.pt/camaras-td-ipc-domes/11461-9554s4dpear2-dome-turret-ipc-5mp-28mm-wdr-ir30-mic-tvt-5600341670440.html",
    image: "https://conteragroup.pt/2689-medium_default/9554s4dpear2-dome-turret-ipc-5mp-28mm-wdr-ir30-mic-tvt.jpg",
    type: "Dome",
    megapixels: 5,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00231",
    brand: "TVT",
    model: "8343IE3N(A/PE/04M/AR5)",
    fullName: "8343IE3N(A/PE/04M/AR5) PTZ IPC 4MP 4X WDR DUAL 50/70M !DA",
    ref: "VDTV-00231",
    price: "344,00 €",
    link: "https://conteragroup.pt/camaras-td-ipc-ptz/13186-8343ie3na-pe-04m-ar5-ptz-ipc-4mp-4x-wdr-dual-50-70m-da-6977749356009.html",
    image: "https://conteragroup.pt/4673-medium_default/8343ie3na-pe-04m-ar5-ptz-ipc-4mp-4x-wdr-dual-50-70m-da.jpg",
    type: "PTZ",
    megapixels: 4,
    lensMotorized: "2.8-12mm",
    lensType: "Motorizada",
    irRange: 70,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: true,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00214",
    brand: "TVT",
    model: "5422E1-VT1(3/PE)",
    fullName: "5422E1-VT1(3/PE) TUBULAR IPC 5MP TÉRMICA 256x192 4/3.2mm VCA",
    ref: "VDTV-00214",
    price: "750,00 €",
    link: "https://conteragroup.pt/camaras-td-ipc-termicas/12986-5422e1-vt13-pe-tubular-ipc-5mp-termica-256x192-4-32mm-vca-5600947296501.html",
    image: "https://conteragroup.pt/4395-medium_default/5422e1-vt13-pe-tubular-ipc-5mp-termica-256x192-4-32mm-vca.jpg",
    type: "Tubular",
    megapixels: 5,
    lensFixed: "3.2mm",
    lensMotorized: "4-3.2mm",
    lensType: "Motorizada",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00230",
    brand: "TVT",
    model: "9443A3BH-A-LR(D/AZ/PE/AR7)",
    fullName: "9443A3BH-A-LR(D/AZ/PE/AR7) LPR TUBULAR IPC 4MP MTZ 8-32mm",
    ref: "VDTV-00230",
    price: "755,73 €",
    link: "https://conteragroup.pt/camaras-td-ipc-tubulares/13185-9443a3bh-a-lrd-az-pe-ar7-lpr-tubular-ipc-4mp-mtz-8-32mm.html",
    image: "https://conteragroup.pt/4672-medium_default/9443a3bh-a-lrd-az-pe-ar7-lpr-tubular-ipc-4mp-mtz-8-32mm.jpg",
    type: "Tubular",
    megapixels: 4,
    lensMotorized: "8-32mm",
    lensType: "Motorizada",
    irRange: 100,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: true,
  },
  {
    id: "tvt-VDTV-00307",
    brand: "TVT",
    model: "9443C4H(AZ/PE/WR3)",
    fullName: "9443C4H(AZ/PE/WR3) TUBULAR IPC 4MP MTZ WDR FColor PRO 1I/O 0",
    ref: "VDTV-00307",
    price: "390,00 €",
    link: "https://conteragroup.pt/camaras-td-ipc-tubulares/13457-9443c4haz-pe-wr3-tubular-ipc-4mp-mtz-wdr-fcolor-pro-1i-o-0.html",
    image: "https://conteragroup.pt/4922-medium_default/9443c4haz-pe-wr3-tubular-ipc-4mp-mtz-wdr-fcolor-pro-1i-o-0.jpg",
    type: "Tubular",
    megapixels: 4,
    lensMotorized: "2.8-12mm",
    lensType: "Motorizada",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00185",
    brand: "TVT",
    model: "K12",
    fullName: "K12 - TECLADO IP 3 EIXOS PARA PTZ RS422 12V 2A/PoE TVT",
    ref: "VDTV-00185",
    price: "579,38 €",
    link: "https://conteragroup.pt/camaras-td-ipc-ptz/12128-k12-teclado-ip-3-eixos-para-ptz-rs422-12v-2a-poe-tvt.html",
    image: "https://conteragroup.pt/3330-medium_default/k12-teclado-ip-3-eixos-para-ptz-rs422-12v-2a-poe-tvt.jpg",
    type: "PTZ",
    megapixels: 0,
    lensType: "Fixa",
    irRange: 0,
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00050",
    brand: "TVT",
    model: "9583S3B(D/AZ/PE/AR3)",
    fullName: "9583S3B(D/AZ/PE/AR3) DOME IPC 8MP MTZ WDR IR50M 1I/O IK10",
    ref: "VDTV-00050",
    price: "337,12 €",
    link: "https://conteragroup.pt/camaras-td-ipc-domes/11474-9583s3bdazpear3-dome-ipc-8mp-mtz-wdr-ir50m-1io-ik10-5600341670952.html",
    image: "https://conteragroup.pt/2702-medium_default/9583s3bdazpear3-dome-ipc-8mp-mtz-wdr-ir50m-1io-ik10.jpg",
    type: "Dome",
    megapixels: 8,
    lensMotorized: "2.8-12mm",
    lensType: "Motorizada",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: true,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00158",
    brand: "TVT",
    model: "5433E1-VT(19/PE)",
    fullName: "5433E1-VT(19/PE) TUBULAR IPC 5MP TÉRMICA 384x288 12/19mm VCA",
    ref: "VDTV-00158",
    price: "2460,00 €",
    link: "https://conteragroup.pt/camaras-td-ipc-termicas/11568-5433e1-vt19pe-tubular-ipc-5mp-termica-384x288-1219mm-vca-5600947297430.html",
    image: "https://conteragroup.pt/3133-medium_default/5433e1-vt19pe-tubular-ipc-5mp-termica-384x288-1219mm-vca.jpg",
    type: "Tubular",
    megapixels: 5,
    lensFixed: "19mm",
    lensMotorized: "12-19mm",
    lensType: "Motorizada",
    irRange: 70,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00046",
    brand: "TVT",
    model: "9545C2(D/AZ/PE/AW3)",
    fullName: "9545C2(D/AZ/PE/AW3) TURRET IPC 4MP MTZ WDR FullColor DI40M",
    ref: "VDTV-00046",
    price: "212,80 €",
    link: "https://conteragroup.pt/camaras-td-ipc-domes/11470-9545c2dazpeaw3-turret-ipc-4mp-mtz-wdr-fullcolor-di40m-5600341670846.html",
    image: "https://conteragroup.pt/2698-medium_default/9545c2dazpeaw3-turret-ipc-4mp-mtz-wdr-fullcolor-di40m.jpg",
    type: "Dome",
    megapixels: 4,
    lensMotorized: "2.8-12mm",
    lensType: "Motorizada",
    irRange: 40,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00157",
    brand: "TVT",
    model: "5422E1-VT1(7/PE)",
    fullName: "5422E1-VT1(7/PE) TUBULAR IPC 5MP TÉRMICA 256x192 8/7mm VCA",
    ref: "VDTV-00157",
    price: "890,00 €",
    link: "https://conteragroup.pt/camaras-td-ipc-termicas/11567-5422e1-vt7pe-tubular-ipc-5mp-termica-256x192-87mm-vca-5600947297423.html",
    image: "https://conteragroup.pt/3145-medium_default/5422e1-vt7pe-tubular-ipc-5mp-termica-256x192-87mm-vca.jpg",
    type: "Tubular",
    megapixels: 5,
    lensFixed: "7mm",
    lensMotorized: "8-7mm",
    lensType: "Motorizada",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00216",
    brand: "TVT",
    model: "9442C4(AZ/PE/WR2)",
    fullName: "9442C4(AZ/PE/WR2) TUBULAR IPC 4MP MTZ WDR FColor PRO LB30M",
    ref: "VDTV-00216",
    price: "187,00 €",
    link: "https://conteragroup.pt/camaras-td-ipc-tubulares/13008-9442c4az-pe-wr2-tubular-ipc-4mp-mtz-wdr-fcolor-pro-lb30m.html",
    image: "https://conteragroup.pt/4417-medium_default/9442c4az-pe-wr2-tubular-ipc-4mp-mtz-wdr-fcolor-pro-lb30m.jpg",
    type: "Tubular",
    megapixels: 4,
    lensMotorized: "2.8-12mm",
    lensType: "Motorizada",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00217",
    brand: "TVT",
    model: "9441C4(PE/WR1)",
    fullName: "9441C4(PE/WR1) TURRET IPC 4MP 2.8mm WDR FColor PRO LB20M",
    ref: "VDTV-00217",
    price: "122,00 €",
    link: "https://conteragroup.pt/camaras-td-ipc-domes/13009-9441c4pe-wr1-turret-ipc-4mp-28mm-wdr-fcolor-pro-lb20m.html",
    image: "https://conteragroup.pt/4418-medium_default/9441c4pe-wr1-turret-ipc-4mp-28mm-wdr-fcolor-pro-lb20m.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 20,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00043",
    brand: "TVT",
    model: "9585S3B(D/AZ/PE/AR3)",
    fullName: "9585S3B(D/AZ/PE/AR3) DOME TURRET IPC 8MP MTZ 2.8-12 WDR IR30",
    ref: "VDTV-00043",
    price: "284,80 €",
    link: "https://conteragroup.pt/camaras-td-ipc-domes/11467-9585s3bdazpear3-dome-turret-ipc-8mp-mtz-28-12-wdr-ir30-5600341670822.html",
    image: "https://conteragroup.pt/4593-medium_default/9585s3bdazpear3-dome-turret-ipc-8mp-mtz-28-12-wdr-ir30.jpg",
    type: "Dome",
    megapixels: 8,
    lensMotorized: "2.8-12mm",
    lensType: "Motorizada",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00161",
    brand: "TVT",
    model: "9581S3B(D/PE/AR2)",
    fullName: "9581S3B(D/PE/AR2) DOME IPC 8MP 2.8mm WDR IR30M IK10",
    ref: "VDTV-00161",
    price: "231,75 €",
    link: "https://conteragroup.pt/camaras-td-ipc-domes/11571-9581s3bdpear2-dome-ipc-8mp-28mm-wdr-ir30m-ik10-5600947297416.html",
    image: "https://conteragroup.pt/3316-medium_default/9581s3bdpear2-dome-ipc-8mp-28mm-wdr-ir30m-ik10.jpg",
    type: "Dome",
    megapixels: 8,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: true,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00145",
    brand: "TVT",
    model: "9462E3B-A(D/AZ/PE/AR3)",
    fullName: "9462E3B-A(D/AZ/PE/AR3) TUBULAR IPC 6MP MTZ VCA 1I/O IR50M",
    ref: "VDTV-00145",
    price: "288,00 €",
    link: "https://conteragroup.pt/camaras-td-ipc-tubulares/11911-9462e3b-ad-az-pe-ar3-tubular-ipc-6mp-mtz-28-12-vca-1i-o-5600947298499.html",
    image: "https://conteragroup.pt/4586-medium_default/9462e3b-ad-az-pe-ar3-tubular-ipc-6mp-mtz-28-12-vca-1i-o.jpg",
    type: "Tubular",
    megapixels: 6,
    lensMotorized: "2.8-12mm",
    lensType: "Motorizada",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00029",
    brand: "TVT",
    model: "9441S4(D/PE/AR2)",
    fullName: "9441S4(D/PE/AR2) TUBULAR IPC 4MP 2.8mm WDR IR30M MIC TVT",
    ref: "VDTV-00029",
    price: "119,17 €",
    link: "https://conteragroup.pt/camaras-td-ipc-tubulares/11453-9441s4dpear2-tubular-ipc-4mp-28mm-wdr-ir30m-mic-tvt-5600341670204.html",
    image: "https://conteragroup.pt/2681-medium_default/9441s4dpear2-tubular-ipc-4mp-28mm-wdr-ir30m-mic-tvt.jpg",
    type: "Tubular",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00348",
    brand: "TVT",
    model: "5433E1-VT2(7/PE)",
    fullName: "5433E1-VT2(7/PE) TUBULAR IPC/TÉRMICA 5MP/384x288 12/7mm VCA",
    ref: "VDTV-00348",
    price: "2460,00 €",
    link: "https://conteragroup.pt/camaras-td-ipc-termicas/13853-5433e1-vt27-pe-tubular-ipc-termica-5mp-384x288-12-7mm-vca.html",
    image: "https://conteragroup.pt/5270-medium_default/5433e1-vt27-pe-tubular-ipc-termica-5mp-384x288-12-7mm-vca.jpg",
    type: "Tubular",
    megapixels: 5,
    lensFixed: "7mm",
    lensType: "Fixa",
    irRange: 12,
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00031",
    brand: "TVT",
    model: "9544S4(D/PE/AR2)",
    fullName: "9544S4(D/PE/AR2) DOME TURRET IPC 4MP 2.8mm WDR IR30M MIC",
    ref: "VDTV-00031",
    price: "117,52 €",
    link: "https://conteragroup.pt/camaras-td-ipc-domes/11455-9544s4dpear2-dome-turret-ipc-4mp-28mm-wdr-ir30m-mic-5600341670228.html",
    image: "https://conteragroup.pt/2683-medium_default/9544s4dpear2-dome-turret-ipc-4mp-28mm-wdr-ir30m-mic.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00162",
    brand: "TVT",
    model: "9441S4L-C(D/PE/AW1)",
    fullName: "9441S4L-C(D/PE/AW1) TUBULAR IPC 4MP 2.8mm 20/30M DUAL",
    ref: "VDTV-00162",
    price: "83,95 €",
    link: "https://conteragroup.pt/camaras-td-ipc-tubulares/11649-9441s4l-cdpeaw1-tubular-ipc-4mp-28mm-dual-2030m-6977749350847.html",
    image: "https://conteragroup.pt/3127-medium_default/9441s4l-cdpeaw1-tubular-ipc-4mp-28mm-dual-2030m.jpg",
    type: "Tubular",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00151",
    brand: "TVT",
    model: "8583IE3N(PE/32M/AR20)",
    fullName: "8583IE3N(PE/32M/AR20) PTZ IPC 8MP 32X WDR STRL IR200M AT VCA",
    ref: "VDTV-00151",
    price: "1532,06 €",
    link: "https://conteragroup.pt/camaras-td-ipc-ptz/11912-8583ie3npe-32m-ar20-ptz-ipc-8mp-32x-wdr-strl-ir200m-at-vca.html",
    image: "https://conteragroup.pt/3131-medium_default/8583ie3npe-32m-ar20-ptz-ipc-8mp-32x-wdr-strl-ir200m-at-vca.jpg",
    type: "PTZ",
    megapixels: 8,
    lensMotorized: "4.8-154mm",
    lensType: "Motorizada",
    irRange: 200,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00032",
    brand: "TVT",
    model: "9545S4(D/AZ/PE/AR3)",
    fullName: "9545S4(D/AZ/PE/AR3) DOME TURRET IPC 4MP MTZ 2.8-12 WDR IR50M",
    ref: "VDTV-00032",
    price: "199,61 €",
    link: "https://conteragroup.pt/camaras-td-ipc-domes/11456-9545s4dazpear3-dome-turret-ipc-4mp-mtz-28-12-wdr-ir50m-5600341670235.html",
    image: "https://conteragroup.pt/2684-medium_default/9545s4dazpear3-dome-turret-ipc-4mp-mtz-28-12-wdr-ir50m.jpg",
    type: "Dome",
    megapixels: 4,
    lensMotorized: "2.8-12mm",
    lensType: "Motorizada",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00222",
    brand: "TVT",
    model: "9482S4-C(D/PE/AW3)",
    fullName: "9482S4-C(D/PE/AW3) TUBULAR IPC 8MP 2.8mm WDR DUAL 30/50M",
    ref: "VDTV-00222",
    price: "220,00 €",
    link: "https://conteragroup.pt/camaras-td-ipc-tubulares/13177-9482s4-cd-pe-aw3-tubular-ipc-8mp-28mm-wdr-dual-30-50m.html",
    image: "https://conteragroup.pt/4664-medium_default/9482s4-cd-pe-aw3-tubular-ipc-8mp-28mm-wdr-dual-30-50m.jpg",
    type: "Tubular",
    megapixels: 8,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00187",
    brand: "TVT",
    model: "9545S4-C(D/AZ/PE/AW3)",
    fullName: "9545S4-C(D/AZ/PE/AW3) TURRET IPC 4MP MTZ WDR DUAL 40/50M TVT",
    ref: "VDTV-00187",
    price: "205,28 €",
    link: "https://conteragroup.pt/camaras-td-ipc-domes/12129-9545s4-cd-az-pe-aw3-dome-turret-ipc-4mp-mtz-wdr-dual-50m-5600947297515.html",
    image: "https://conteragroup.pt/4589-medium_default/9545s4-cd-az-pe-aw3-dome-turret-ipc-4mp-mtz-wdr-dual-50m.jpg",
    type: "Dome",
    megapixels: 4,
    lensMotorized: "2.8-12mm",
    lensType: "Motorizada",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00140",
    brand: "TVT",
    model: "9846SP1(D/G4/WR2)",
    fullName: "9846SP1(D/G4/WR2) TUBULAR SOLAR 4MP 2.8mm IR20M 4G S/BAT",
    ref: "VDTV-00140",
    price: "692,47 €",
    link: "https://conteragroup.pt/camaras-td-ipc-tubulares/12040-9846sp1d-g4-wr2-tubular-solar-4mp-28mm-ir100m-4g-s-bat.html",
    image: "https://conteragroup.pt/3309-medium_default/9846sp1d-g4-wr2-tubular-solar-4mp-28mm-ir100m-4g-s-bat.jpg",
    type: "Tubular",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 20,
    wdrType: "WDR",
    hasWifi: false,
    has4G: true,
    hasSolar: true,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: false,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00215",
    brand: "TVT",
    model: "9585C2H-PA(D/PE/AW3)",
    fullName: "9585C2H-PA(D/PE/AW3) TURRET IPC 8MP 2.8mm WDR DUAL 40M !DA",
    ref: "VDTV-00215",
    price: "330,00 €",
    link: "https://conteragroup.pt/camaras-td-ipc-domes/13007-9585c2h-pad-pe-aw3-turret-ipc-8mp-28mm-wdr-1i-o-dual-40m.html",
    image: "https://conteragroup.pt/4416-medium_default/9585c2h-pad-pe-aw3-turret-ipc-8mp-28mm-wdr-1i-o-dual-40m.jpg",
    type: "Dome",
    megapixels: 8,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 40,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00142",
    brand: "TVT",
    model: "8443IS2N(PE/25M/AR16)",
    fullName: "8443IS2N(PE/25M/AR16) PTZ IPC 4MP 25X WDR STRL IR160M AT VCA",
    ref: "VDTV-00142",
    price: "727,90 €",
    link: "https://conteragroup.pt/camaras-td-ipc-ptz/12042-8443is2npe-25m-ar16-ptz-ipc-4mp-25x-wdr-strl-ir160m-at-vca-6977749356016.html",
    image: "https://conteragroup.pt/3305-medium_default/8443is2npe-25m-ar16-ptz-ipc-4mp-25x-wdr-strl-ir160m-at-vca.jpg",
    type: "PTZ",
    megapixels: 4,
    lensMotorized: "4.8-120mm",
    lensType: "Motorizada",
    irRange: 160,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00199",
    brand: "TVT",
    model: "9742A3-PC",
    fullName: "9742A3-PC IPC 4MP DUPLA LENTE 2.1mm p/ CONTAGEM DE PESSOAS",
    ref: "VDTV-00199",
    price: "756,00 €",
    link: "https://conteragroup.pt/camaras-td-ipc-domes/12953-9742a3-pc-ipc-4mp-dupla-lente-21mm-p-contagem-de-pessoas-6977749353510.html",
    image: "https://conteragroup.pt/4458-medium_default/9742a3-pc-ipc-4mp-dupla-lente-21mm-p-contagem-de-pessoas.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "2.1mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "DWDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: false,
    detPeople: true,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00044",
    brand: "TVT",
    model: "9568E3BL(D/PE/AR2)",
    fullName: "9568E3BL(D/PE/AR2) FISHEYE IPC 6MP 1.1mm DWDR 1I/O MIC TVT",
    ref: "VDTV-00044",
    price: "130,19 €",
    link: "https://conteragroup.pt/camaras-td-ipc-fisheye/11468-9568e3bldpear2-fisheye-ipc-6mp-11mm-dwdr-1io-mic-tvt.html",
    image: "https://conteragroup.pt/2696-medium_default/9568e3bldpear2-fisheye-ipc-6mp-11mm-dwdr-1io-mic-tvt.jpg",
    type: "Fisheye",
    megapixels: 6,
    lensFixed: "1.1mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "DWDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00086",
    brand: "TVT",
    model: "5422E1-VT(3/PE)",
    fullName: "5422E1-VT(3/PE) TUBULAR IPC 5MP TÉRMICA 256x192 4/3.2mm VCA",
    ref: "VDTV-00086",
    price: "847,79 €",
    link: "https://conteragroup.pt/camaras-td-ipc-termicas/11510-5422e1-vt3pe-tubular-ipc-5mp-termica-256x192--432mm-vca-5600341671461.html",
    image: "https://conteragroup.pt/2738-medium_default/5422e1-vt3pe-tubular-ipc-5mp-termica-256x192--432mm-vca.jpg",
    type: "Tubular",
    megapixels: 5,
    lensFixed: "3.2mm",
    lensMotorized: "3.2-4mm",
    lensType: "Motorizada",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00110",
    brand: "TVT",
    model: "9442E3B(D/PE/AR3)",
    fullName: "9442E3B(D/PE/AR3) TUBULAR IPC 4MP 2.8mm WDR IR50M VCA",
    ref: "VDTV-00110",
    price: "256,47 €",
    link: "https://conteragroup.pt/camaras-td-ipc-tubulares/12156-9442e3bd-pe-ar3-tubular-ipc-4mp-28mm-wdr-ir50m-vca-5600341672055.html",
    image: "https://conteragroup.pt/3453-medium_default/9442e3bd-pe-ar3-tubular-ipc-4mp-28mm-wdr-ir50m-vca.jpg",
    type: "Tubular",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "tvt-VDTV-00350",
    brand: "TVT",
    model: "5635E1-VT2(PE/432/VL30/25MM)",
    fullName: "5635E1-VT2(PE/432/VL30/25MM) PTZ IPC ÓTICA+TÉRMICA 32X+25mm",
    ref: "VDTV-00350",
    price: "4590,00 €",
    link: "https://conteragroup.pt/camaras-td-ipc-termicas/13878-5635e1-vt2pe-432-vl30-25mm-ptz-ipc-oticatermica-32x25mm.html",
    image: "https://conteragroup.pt/img/p/pt-default-medium_default.jpg",
    type: "PTZ",
    megapixels: 0,
    lensFixed: "25mm",
    lensType: "Fixa",
    irRange: 30,
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10372",
    brand: "DAHUA",
    model: "IPC-HFW2441T-ZS",
    fullName: "Tubular IPC-HFW2441T-ZS 4MP Mtz 2.7-13.5mm IR60M WSENSE",
    ref: "VDDH-10372",
    price: "256,00 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/11314-tubular-ipc-hfw2441t-zs-ip-4mp-mtz-27-135mm-ir60m-wsense-6923172548542.html",
    image: "https://conteragroup.pt/2553-medium_default/tubular-ipc-hfw2441t-zs-ip-4mp-mtz-27-135mm-ir60m-wsense.jpg",
    type: "Tubular",
    megapixels: 4,
    lensMotorized: "2.7-13.5mm",
    lensType: "Motorizada",
    irRange: 60,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10382",
    brand: "DAHUA",
    model: "IPC-HFW2441S-S",
    fullName: "Tubular IPC-HFW2441S-S IP 4MP 2.8mm IR30M WSENSE DAHUA",
    ref: "VDDH-10382",
    price: "158,00 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/11319-tubular-ipc-hfw2441s-s-ip-4mp-28mm-ir30m-wsense-dahua-6923172539830.html",
    image: "https://conteragroup.pt/2558-medium_default/tubular-ipc-hfw2441s-s-ip-4mp-28mm-ir30m-wsense-dahua.jpg",
    type: "Tubular",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10379",
    brand: "DAHUA",
    model: "IPC-HDBW2441R-ZS-B",
    fullName: "Dome IPC-HDBW2441R-ZS-B PRETA 4MP MTZ 2.7-13.5 IR40M WSENSE",
    ref: "VDDH-10379",
    price: "241,33 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11793-dome-ipc-hdbw2441r-zs-b-4mp-mtz-27-135-ir40m-preta-wsense-6923172565938.html",
    image: "https://conteragroup.pt/2944-medium_default/dome-ipc-hdbw2441r-zs-b-4mp-mtz-27-135-ir40m-preta-wsense.jpg",
    type: "Dome",
    megapixels: 4,
    lensMotorized: "2.7-13.5mm",
    lensType: "Motorizada",
    irRange: 40,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10260",
    brand: "DAHUA",
    model: "IPC-HFW2449S-S-IL",
    fullName: "Tubular IPC-HFW2449S-S-IL 4MP 2.8mm IR30M DUAL WSENSE DAHUA",
    ref: "VDDH-10260",
    price: "174,00 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/11248-tubular-ipc-hfw2449s-s-il-4mp-28mm-ir30m-dual-fcolor-wsense-6923172537744.html",
    image: "https://conteragroup.pt/2490-medium_default/tubular-ipc-hfw2449s-s-il-4mp-28mm-ir30m-dual-fcolor-wsense.jpg",
    type: "Tubular",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10676",
    brand: "DAHUA",
    model: "IPC-HFW3449E-S-IL",
    fullName: "Tubular IPC-HFW3449E-S-IL 4MP 2.8mm IR50M DUAL WSENSE DAHUA",
    ref: "VDDH-10676",
    price: "234,00 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/12615-tubular-ipc-hfw3449e-s-il-4mp-28mm-ir80m-ip67-wsense-dahua.html",
    image: "https://conteragroup.pt/3960-medium_default/tubular-ipc-hfw3449e-s-il-4mp-28mm-ir80m-ip67-wsense-dahua.jpg",
    type: "Tubular",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 80,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10380",
    brand: "DAHUA",
    model: "IPC-HDBW2441E-S",
    fullName: "Dome IPC-HDBW2441E-S 4MP 2.8mm IR30M IK10 WSENSE DAHUA",
    ref: "VDDH-10380",
    price: "170,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11318-dome-ipc-hdbw2441e-s-4mp-28mm-ir30m-ik10-wsense-dahua-6923172546739.html",
    image: "https://conteragroup.pt/2557-medium_default/dome-ipc-hdbw2441e-s-4mp-28mm-ir30m-ik10-wsense-dahua.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: true,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10731",
    brand: "DAHUA",
    model: "IPC-HDW3449QM-S-IL",
    fullName: "Dome IPC-HDW3449QM-S-IL 4MP 2.8mm IR50M DUAL WSENSE DAHUA",
    ref: "VDDH-10731",
    price: "234,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/13050-dome-ipc-hdw3449qm-s-il-4mp-28mm-ir50m-ip67-wsense-dahua-6939554914287.html",
    image: "https://conteragroup.pt/4470-medium_default/dome-ipc-hdw3449qm-s-il-4mp-28mm-ir50m-ip67-wsense-dahua.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10398",
    brand: "DAHUA",
    model: "IPC-HDW2241T-S",
    fullName: "Dome IPC-HDW2241T-S IP 2MP 2.8mm IR30M WDR WSENSE DAHUA",
    ref: "VDDH-10398",
    price: "138,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11329-dome-ipc-hdw2241t-s-ip-2mp-28mm-ir30m-wdr-wsense-dahua-6923172539854.html",
    image: "https://conteragroup.pt/2568-medium_default/dome-ipc-hdw2241t-s-ip-2mp-28mm-ir30m-wdr-wsense-dahua.jpg",
    type: "Dome",
    megapixels: 2,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10257",
    brand: "DAHUA",
    model: "IPC-HDBW1430DE-SW",
    fullName: "Dome IPC-HDBW1430DE-SW IP 4MP WI-FI 2.8mm IR30M IK10 DAHUA",
    ref: "VDDH-10257",
    price: "135,95 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11245-dome-ipc-hdbw1430de-sw-ip-4mp-wi-fi-28mm-ir30m-ik10-dahua-6923172539984.html",
    image: "https://conteragroup.pt/2487-medium_default/dome-ipc-hdbw1430de-sw-ip-4mp-wi-fi-28mm-ir30m-ik10-dahua.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "DWDR",
    hasWifi: true,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: true,
    hasPOE: false,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10442",
    brand: "DAHUA",
    model: "IPC-HDBW2241E-S",
    fullName: "Dome IPC-HDBW2241E-S 2MP 2.8mm IR30M WDR IK10 WSENSE",
    ref: "VDDH-10442",
    price: "158,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11347-dome-ipc-hdbw2241e-s-2mp-28mm-ir30m-wdr-ik10-wsense-6923172546760.html",
    image: "https://conteragroup.pt/2582-medium_default/dome-ipc-hdbw2241e-s-2mp-28mm-ir30m-wdr-ik10-wsense.jpg",
    type: "Dome",
    megapixels: 2,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: true,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10532",
    brand: "DAHUA",
    model: "IPC-HDW3449H-AS-PV-S5",
    fullName: "Dome IPC-HDW3449H-AS-PV-S5 IP 4MP 2.8mm IR30M AcuPick TIOC",
    ref: "VDDH-10532",
    price: "281,50 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11613-dome-ipc-hdw3449h-as-pv-s5-ip-4mp-28mm-ir30m-acupick-tioc-6923172526748.html",
    image: "https://conteragroup.pt/2951-medium_default/dome-ipc-hdw3449h-as-pv-s5-ip-4mp-28mm-ir30m-acupick-tioc.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10512",
    brand: "DAHUA",
    model: "IPC-HDW2449T-S-IL",
    fullName: "Dome IPC-HDW2449T-S-IL 4MP 2.8mm IR30M DUAL WSENSE DAHUA",
    ref: "VDDH-10512",
    price: "174,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11810-dome-ipc-hdw2449t-s-il-4mp-28mm-ir30m-ip67-wsense-dahua-6923172537782.html",
    image: "https://conteragroup.pt/2941-medium_default/dome-ipc-hdw2449t-s-il-4mp-28mm-ir30m-ip67-wsense-dahua.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10588",
    brand: "DAHUA",
    model: "IPC-HDW2449T-ZS-IL",
    fullName: "Dome IPC-HDW2449T-ZS-IL 4MP MTZ 2.7-13.5mm IR40M DUAL WSENSE",
    ref: "VDDH-10588",
    price: "258,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/12030-dome-ipc-hdw2449t-zs-il-4mp-mtz-27-135mm-ir40m-poe-wsense-6939554923593.html",
    image: "https://conteragroup.pt/3546-medium_default/dome-ipc-hdw2449t-zs-il-4mp-mtz-27-135mm-ir40m-poe-wsense.jpg",
    type: "Dome",
    megapixels: 4,
    lensMotorized: "2.7-13.5mm",
    lensType: "Motorizada",
    irRange: 40,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10485",
    brand: "DAHUA",
    model: "IPC-HFW2241T-ZS",
    fullName: "Tubular IPC-HFW2241T-ZS 2MP MTZ 2.7-13.5mm IR60M WSENSE DAHU",
    ref: "VDDH-10485",
    price: "224,00 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/11367-tubular-ipc-hfw2241t-zs-2mp-mtz-27-135mm-ir60m-wsense-ip67-6923172548580.html",
    image: "https://conteragroup.pt/2596-medium_default/tubular-ipc-hfw2241t-zs-2mp-mtz-27-135mm-ir60m-wsense-ip67.jpg",
    type: "Tubular",
    megapixels: 2,
    lensMotorized: "2.7-13.5mm",
    lensType: "Motorizada",
    irRange: 60,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10386",
    brand: "DAHUA",
    model: "IPC-HDW2441T-ZS",
    fullName: "Dome IPC-HDW2441T-ZS 4MP Mtz 2.7-13.5mm IR40M WSENSE DAHUA",
    ref: "VDDH-10386",
    price: "252,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11321-dome-ipc-hdw2441t-zs-4mp-mtz-27-135mm-ir40m-wsense-dahua-6923172545145.html",
    image: "https://conteragroup.pt/3964-medium_default/dome-ipc-hdw2441t-zs-4mp-mtz-27-135mm-ir40m-wsense-dahua.jpg",
    type: "Dome",
    megapixels: 4,
    lensMotorized: "2.7-13.5mm",
    lensType: "Motorizada",
    irRange: 40,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10378",
    brand: "DAHUA",
    model: "IPC-HDBW2441R-ZS",
    fullName: "Dome IPC-HDBW2441R-ZS 4MP MTZ 2.7-13.5mm IR40M WSENSE",
    ref: "VDDH-10378",
    price: "256,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11317-dome-ipc-hdbw2441r-zs-4mp-mtz-27-135mm-ir40m-wsense-6923172536815.html",
    image: "https://conteragroup.pt/2556-medium_default/dome-ipc-hdbw2441r-zs-4mp-mtz-27-135mm-ir40m-wsense.jpg",
    type: "Dome",
    megapixels: 4,
    lensMotorized: "2.7-13.5mm",
    lensType: "Motorizada",
    irRange: 40,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10687",
    brand: "DAHUA",
    model: "IPC-HFW3449T-ZS-IL",
    fullName: "Tubular IPC-HFW3449T-ZS-IL 4MP MTZ 2.7-13.5 IR60 DUAL WSENSE",
    ref: "VDDH-10687",
    price: "356,00 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/12959-tubular-ipc-hfw3449t-zs-il-4mp-mtz-27-135mm-ir60m-wsense-6939554927102.html",
    image: "https://conteragroup.pt/4367-medium_default/tubular-ipc-hfw3449t-zs-il-4mp-mtz-27-135mm-ir60m-wsense.jpg",
    type: "Tubular",
    megapixels: 4,
    lensMotorized: "2.7-13.5mm",
    lensType: "Motorizada",
    irRange: 60,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10384",
    brand: "DAHUA",
    model: "IPC-HDW2441T-S",
    fullName: "Dome IPC-HDW2441T-S 4MP 2.8mm IR30M WSENSE DAHUA",
    ref: "VDDH-10384",
    price: "158,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11320-dome-ipc-hdw2441t-s-4mp-28mm-ir30m-wsense-dahua-6923172539878.html",
    image: "https://conteragroup.pt/2559-medium_default/dome-ipc-hdw2441t-s-4mp-28mm-ir30m-wsense-dahua.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10514",
    brand: "DAHUA",
    model: "IPC-HDW2841TM-S",
    fullName: "Dome IPC-HDW2841TM-S 8MP 2.8mm IR30M IP67 WSENSE DAHUA",
    ref: "VDDH-10514",
    price: "268,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11812-dome-ipc-hdw2841tm-s-8mp-28mm-ir30m-ip67-wsense-dahua-6923172581136.html",
    image: "https://conteragroup.pt/2952-medium_default/dome-ipc-hdw2841tm-s-8mp-28mm-ir30m-ip67-wsense-dahua.jpg",
    type: "Dome",
    megapixels: 8,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10776",
    brand: "DAHUA",
    model: "IPC-HFW3449T1-ZAS-PV-PRO",
    fullName: "Tubular IPC-HFW3449T1-ZAS-PV-PRO 4MP MTZ 2.7-12mm IR60 TiOC",
    ref: "VDDH-10776",
    price: "496,00 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/13478-tubular-ipc-hfw3449t1-zas-pv-pro-4mp-mtz-27-12mm-ir60-tioc-6937552411562.html",
    image: "https://conteragroup.pt/4969-medium_default/tubular-ipc-hfw3449t1-zas-pv-pro-4mp-mtz-27-12mm-ir60-tioc.jpg",
    type: "Tubular",
    megapixels: 4,
    lensMotorized: "2.7-12mm",
    lensType: "Motorizada",
    irRange: 60,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10385",
    brand: "DAHUA",
    model: "IPC-HDW2441T-S-B",
    fullName: "Dome IPC-HDW2441T-S-B PRETA 4MP 2.8mm IR30M WSENSE DAHUA",
    ref: "VDDH-10385",
    price: "150,20 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11796-dome-ipc-hdw2441t-s-b-preta-4mp-28mm-ir30m-wsense-dahua-6923172565969.html",
    image: "https://conteragroup.pt/2939-medium_default/dome-ipc-hdw2441t-s-b-preta-4mp-28mm-ir30m-wsense-dahua.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10672",
    brand: "DAHUA",
    model: "IPC-HDW2541T-ZS-S2",
    fullName: "Dome IPC-HDW2541T-ZS-S2 5MP 2.7-13.5mm IR40M WSENSE DAHUA",
    ref: "VDDH-10672",
    price: "284,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/12612-dome-ipc-hdw2541t-zs-s2-5mp-27-135mm-ir40m-poe-ip67-wsense-6923172581778.html",
    image: "https://conteragroup.pt/3957-medium_default/dome-ipc-hdw2541t-zs-s2-5mp-27-135mm-ir40m-poe-ip67-wsense.jpg",
    type: "Dome",
    megapixels: 5,
    lensMotorized: "2.7-13.5mm",
    lensType: "Motorizada",
    irRange: 40,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10497",
    brand: "DAHUA",
    model: "ITC413-PW4D-IZ1",
    fullName: "LPR Tubular ITC413-PW4D-IZ1 IP 4MP MTZ 2.7-12mm IR10M IK10 D",
    ref: "VDDH-10497",
    price: "485,35 €",
    link: "https://conteragroup.pt/camaras-anpr/11850-lpr-tubular-itc413-pw4d-iz1-ip-4mp-mtz-27-12mm-ir10m-dahua-6923172581389.html",
    image: "https://conteragroup.pt/3062-medium_default/lpr-tubular-itc413-pw4d-iz1-ip-4mp-mtz-27-12mm-ir10m-dahua.jpg",
    type: "Tubular",
    megapixels: 4,
    lensMotorized: "2.7-12mm",
    lensType: "Motorizada",
    irRange: 10,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: true,
    hasPOE: false,
    detPeople: false,
    detVehicle: false,
    hasLPR: true,
  },
  {
    id: "dahua-VDDH-10705",
    brand: "DAHUA",
    model: "IPC-HFW2441DG-4G-SP-B-MAX",
    fullName: "Tubular IPC-HFW2441DG-4G-SP-B-MAX 4MP 3.6mm IR30M 4G SOLAR",
    ref: "VDDH-10705",
    price: "542,00 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/12977-tubular-ipc-hfw2441dg-4g-sp-b-max-4mp-36mm-ir30m-4g-solar-6939554936456.html",
    image: "https://conteragroup.pt/4385-medium_default/tubular-ipc-hfw2441dg-4g-sp-b-max-4mp-36mm-ir30m-4g-solar.jpg",
    type: "Tubular",
    megapixels: 4,
    lensFixed: "3.6mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "DWDR",
    hasWifi: false,
    has4G: true,
    hasSolar: true,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: false,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10751",
    brand: "DAHUA",
    model: "IPC-HDW3449H-AS-PV-S5-B",
    fullName: "Dome IPC-HDW3449H-AS-PV-S5-B PRETA 4MP 2.8mm IR30M TIOC",
    ref: "VDDH-10751",
    price: "358,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/13114-dome-ipc-hdw3449h-as-pv-s5-b-ip-4mp-28mm-ir30m-preta-tioc-6939554989131.html",
    image: "https://conteragroup.pt/4602-medium_default/dome-ipc-hdw3449h-as-pv-s5-b-ip-4mp-28mm-ir30m-preta-tioc.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10589",
    brand: "DAHUA",
    model: "IPC-HFW2449T-ZAS-IL",
    fullName: "Tubular IPC-HFW2449T-ZAS-IL 4MP MTZ 2.7-13.5 IR60 DUAL WSENS",
    ref: "VDDH-10589",
    price: "272,00 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/12031-tubular-ipc-hfw2449t-zas-il-4mp-mtz-27-135mm-ir60m-wsense-6939554923562.html",
    image: "https://conteragroup.pt/3545-medium_default/tubular-ipc-hfw2449t-zas-il-4mp-mtz-27-135mm-ir60m-wsense.jpg",
    type: "Tubular",
    megapixels: 4,
    lensMotorized: "2.7-13.5mm",
    lensType: "Motorizada",
    irRange: 60,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10800",
    brand: "DAHUA",
    model: "IPC-HDBW5859E1-ZE-IL",
    fullName: "Dome IPC-HDBW5859E1-ZE-IL 8MP MTZ 8-32mm IR50M WMIND",
    ref: "VDDH-10800",
    price: "882,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/13500-dome-ipc-hdbw5859e1-ze-il-8mp-mtz-8-32mm-ir50m-wmind-6937552412538.html",
    image: "https://conteragroup.pt/5007-medium_default/dome-ipc-hdbw5859e1-ze-il-8mp-mtz-8-32mm-ir50m-wmind.jpg",
    type: "Dome",
    megapixels: 8,
    lensMotorized: "8-32mm",
    lensType: "Motorizada",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10738",
    brand: "DAHUA",
    model: "IPC-HDBW2241E-S",
    fullName: "Dome IPC-HDBW2241E-S 2MP 3.6mm IR30M WDR IK10 WSENSE",
    ref: "VDDH-10738",
    price: "142,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/13064-dome-ipc-hdbw2241e-s-2mp-36mm-ir30m-wdr-ik10-wsense-6923172546722.html",
    image: "https://conteragroup.pt/4515-medium_default/dome-ipc-hdbw2241e-s-2mp-36mm-ir30m-wdr-ik10-wsense.jpg",
    type: "Dome",
    megapixels: 2,
    lensFixed: "3.6mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: true,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10387",
    brand: "DAHUA",
    model: "IPC-HDW2441T-ZS-B",
    fullName: "Dome IPC-HDW2441T-ZS-B PRETA 4MP Mtz 2.7-13.5mm IR40M WSENSE",
    ref: "VDDH-10387",
    price: "238,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11797-dome-ipc-hdw2441t-zs-b-preta-4mp-mtz-27-135mm-ir40m-wsense-6923172565983.html",
    image: "https://conteragroup.pt/2937-medium_default/dome-ipc-hdw2441t-zs-b-preta-4mp-mtz-27-135mm-ir40m-wsense.jpg",
    type: "Dome",
    megapixels: 4,
    lensMotorized: "2.7-13.5mm",
    lensType: "Motorizada",
    irRange: 40,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10383",
    brand: "DAHUA",
    model: "IPC-HFW2441S-S-B",
    fullName: "Tubular IPC-HFW2441S-S-B PRETA 4MP 2.8mm IR30M WSENSE DAHUA",
    ref: "VDDH-10383",
    price: "142,00 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/11795-tubular-ipc-hfw2441s-s-b-preta-4mp-28mm-ir30m-wsense-dahua-6923172565952.html",
    image: "https://conteragroup.pt/3040-medium_default/tubular-ipc-hfw2441s-s-b-preta-4mp-28mm-ir30m-wsense-dahua.jpg",
    type: "Tubular",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10752",
    brand: "DAHUA",
    model: "IPC-HFW1539DTK1-SW-PV",
    fullName: "Tubular IPC-HFW1539DTK1-SW-PV 5MP 2.8mm WIFI IR30M DAHUA",
    ref: "VDDH-10752",
    price: "106,00 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/13169-tubular-ipc-hfw1539dtk1-sw-pv-5mp-28mm-wifi-ir30m-dahua-6939554980602.html",
    image: "https://conteragroup.pt/4656-medium_default/tubular-ipc-hfw1539dtk1-sw-pv-5mp-28mm-wifi-ir30m-dahua.jpg",
    type: "Tubular",
    megapixels: 5,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "DWDR",
    hasWifi: true,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: false,
    hasIK10: false,
    hasPOE: false,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10709",
    brand: "DAHUA",
    model: "IPC-HDW3649H-AS-PV-PRO",
    fullName: "Dome IPC-HDW3649H-AS-PV-PRO 6MP 2.8mm IR30M PRO TIOC DAHUA",
    ref: "VDDH-10709",
    price: "396,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/12981-dome-ipc-hdw3649h-as-pv-pro-6mp-28mm-ir30m-pro-tioc-dahua-6939554976247.html",
    image: "https://conteragroup.pt/4389-medium_default/dome-ipc-hdw3649h-as-pv-pro-6mp-28mm-ir30m-pro-tioc-dahua.jpg",
    type: "Dome",
    megapixels: 6,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10637",
    brand: "DAHUA",
    model: "IPC-HFW2441T-ZS-B",
    fullName: "Tubular IPC-HFW2441T-ZS-B PRETA 4MP Mtz 2.7-13.5mm IR60M DAH",
    ref: "VDDH-10637",
    price: "240,49 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/12203-tubular-ipc-hfw2441t-zs-b-ip-4mp-mtz-27-135mm-ir60m-preta-6923172552198.html",
    image: "https://conteragroup.pt/3523-medium_default/tubular-ipc-hfw2441t-zs-b-ip-4mp-mtz-27-135mm-ir60m-preta.jpg",
    type: "Tubular",
    megapixels: 4,
    lensMotorized: "2.7-13.5mm",
    lensType: "Motorizada",
    irRange: 60,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10799",
    brand: "DAHUA",
    model: "IPC-HDBW5859E1-ZE-IL",
    fullName: "Dome IPC-HDBW5859E1-ZE-IL 8MP MTZ 2.7-12mm IR50M WMIND",
    ref: "VDDH-10799",
    price: "766,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/13499-dome-ipc-hdbw5859e1-ze-il-8mp-mtz-27-12mm-ir50m-wmind-6937552412514.html",
    image: "https://conteragroup.pt/5008-medium_default/dome-ipc-hdbw5859e1-ze-il-8mp-mtz-27-12mm-ir50m-wmind.jpg",
    type: "Dome",
    megapixels: 8,
    lensMotorized: "2.7-12mm",
    lensType: "Motorizada",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10718",
    brand: "DAHUA",
    model: "IPC-HDW3449H-AS-PV-PRO",
    fullName: "Dome IPC-HDW3449H-AS-PV-PRO 4MP 2.8mm IR30M WIZCOLOR TIOC",
    ref: "VDDH-10718",
    price: "360,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/13031-dome-ipc-hdw3449h-as-pv-pro-4mp-28mm-ir30m-wizcolor-tioc-6939554944505.html",
    image: "https://conteragroup.pt/4450-medium_default/dome-ipc-hdw3449h-as-pv-pro-4mp-28mm-ir30m-wizcolor-tioc.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10445",
    brand: "DAHUA",
    model: "IPC-HFW2841T-ZS",
    fullName: "Tubular IPC-HFW2841T-ZS 8MP MTZ 2.7-13.5mm IR60M WSENSE DAHU",
    ref: "VDDH-10445",
    price: "412,00 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/11350-tubular-ipc-hfw2841t-zs-8mp-mtz-27-135mm-ir60m-wsense-dahu-6923172581891.html",
    image: "https://conteragroup.pt/2585-medium_default/tubular-ipc-hfw2841t-zs-8mp-mtz-27-135mm-ir60m-wsense-dahu.jpg",
    type: "Tubular",
    megapixels: 8,
    lensMotorized: "2.7-13.5mm",
    lensType: "Motorizada",
    irRange: 60,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10537",
    brand: "DAHUA",
    model: "IPC-HFW5442T-SE-S3",
    fullName: "Tubular IPC-HFW5442T-SE-S3 4MP 2.8mm IR80M ePoE IK10 WMIND",
    ref: "VDDH-10537",
    price: "316,00 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/11618-tubular-ipc-hfw5442t-se-s3-a-4mp-28mm-ir80m-poe-wmind.html",
    image: "https://conteragroup.pt/3045-medium_default/tubular-ipc-hfw5442t-se-s3-a-4mp-28mm-ir80m-poe-wmind.jpg",
    type: "Tubular",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 80,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: true,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10747",
    brand: "DAHUA",
    model: "IPC-HDBW3449E-S-IL",
    fullName: "Dome IPC-HDBW3449E-S-IL 4MP 2.8mm IR40M DUAL IK10 WSENSE",
    ref: "VDDH-10747",
    price: "236,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/13110-dome-ipc-hdbw3449e-s-il-4mp-28mm-ir40m-dual-ik10-wsense-6939554920721.html",
    image: "https://conteragroup.pt/4596-medium_default/dome-ipc-hdbw3449e-s-il-4mp-28mm-ir40m-dual-ik10-wsense.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 40,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: true,
    hasAI: true,
    hasIK10: true,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10772",
    brand: "DAHUA",
    model: "IPC-HDW3449H-ZAS-PV",
    fullName: "Dome IPC-HDW3449H-ZAS-PV 4MP 2.7-13mm MTZ IR50M TIOC DAHUA",
    ref: "VDDH-10772",
    price: "480,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/13474-dome-ipc-hdw3449h-zas-pv-4mp-27-13mm-mtz-ir50m-tioc-dahua-6923172504166.html",
    image: "https://conteragroup.pt/4965-medium_default/dome-ipc-hdw3449h-zas-pv-4mp-27-13mm-mtz-ir50m-tioc-dahua.jpg",
    type: "Dome",
    megapixels: 4,
    lensMotorized: "2.7-13.5mm",
    lensType: "Motorizada",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10466",
    brand: "DAHUA",
    model: "IPC-PFW3849S-A180-AS-PV",
    fullName: "Tubular IPC-PFW3849S-A180-AS-PV 8MP 2x4MP 2.8 180° IR25 TIOC",
    ref: "VDDH-10466",
    price: "498,00 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/11553-tubular-ipc-pfw3849s-a180-as-pv-2x4mp-28mm-180o-ir25m-tioc-6923172594327.html",
    image: "https://conteragroup.pt/3496-medium_default/tubular-ipc-pfw3849s-a180-as-pv-2x4mp-28mm-180o-ir25m-tioc.jpg",
    type: "Tubular",
    megapixels: 8,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 25,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10443",
    brand: "DAHUA",
    model: "IPC-HDBW2841E-S",
    fullName: "Dome IPC-HDBW2841E-S 8MP 2.8mm IR30M IK10 WSENSE DAHUA",
    ref: "VDDH-10443",
    price: "256,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11348-dome-ipc-hdbw2841e-s-8mp-28mm-ir30m-ik10-wsense-dahua-6923172582249.html",
    image: "https://conteragroup.pt/2583-medium_default/dome-ipc-hdbw2841e-s-8mp-28mm-ir30m-ik10-wsense-dahua.jpg",
    type: "Dome",
    megapixels: 8,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: true,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10817",
    brand: "DAHUA",
    model: "IPC-HFW5459T-ASE-IL",
    fullName: "Tubular IPC-HFW5459T-ASE-IL 4MP 2.8mm IR60M WMIND DAHUA",
    ref: "VDDH-10817",
    price: "406,00 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/13388-tubular-ipc-hfw5459t-ase-il-4mp-28mm-ir60m-wmind-dahua-6937552413412.html",
    image: "https://conteragroup.pt/5019-medium_default/tubular-ipc-hfw5459t-ase-il-4mp-28mm-ir60m-wmind-dahua.jpg",
    type: "Tubular",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 60,
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10447",
    brand: "DAHUA",
    model: "IPC-HDBW2541E-S",
    fullName: "Dome IPC-HDBW2541E-S 5MP 2.8mm IR30M IK10 WSENSE DAHUA",
    ref: "VDDH-10447",
    price: "198,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11352-dome-ipc-hdbw2541e-s-5mp-28mm-ir30m-ik10-wsense-dahua-6923172582355.html",
    image: "https://conteragroup.pt/2587-medium_default/dome-ipc-hdbw2541e-s-5mp-28mm-ir30m-ik10-wsense-dahua.jpg",
    type: "Dome",
    megapixels: 5,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: true,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10749",
    brand: "DAHUA",
    model: "IPC-HFW3849T-ZS-IL",
    fullName: "Tubular IPC-HFW3849T-ZS-IL 8MP MTZ 2.7-13mm IR60M DUAL WSENS",
    ref: "VDDH-10749",
    price: "518,00 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/13112-tubular-ipc-hfw3849t-zs-il-8mp-mtz-ir60m-dupla-ilum-wsense-6939554927133.html",
    image: "https://conteragroup.pt/4598-medium_default/tubular-ipc-hfw3849t-zs-il-8mp-mtz-ir60m-dupla-ilum-wsense.jpg",
    type: "Tubular",
    megapixels: 8,
    lensMotorized: "2.7-13.5mm",
    lensType: "Motorizada",
    irRange: 60,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-00758",
    brand: "DAHUA",
    model: "IPC-EW5541-AS",
    fullName: "Fisheye IPC-EW5541-AS IP 5MP IR10M 1.4mm PoE WMIND DAHUA",
    ref: "VDDH-00758",
    price: "167,88 €",
    link: "https://conteragroup.pt/camaras-ipc-fisheye/10970-fisheye-ipc-ew5541-as-ip-5mp-ir10m-14mm-poe-wmind-dahua-6939554993855.html",
    image: "https://conteragroup.pt/2213-medium_default/fisheye-ipc-ew5541-as-ip-5mp-ir10m-14mm-poe-wmind-dahua.jpg",
    type: "Fisheye",
    megapixels: 5,
    lensFixed: "1.4mm",
    lensType: "Fixa",
    irRange: 10,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10444",
    brand: "DAHUA",
    model: "IPC-HFW2841S-S",
    fullName: "Tubular IPC-HFW2841S-S 8MP 2.8mm IR30M WDR WSENSE DAHUA",
    ref: "VDDH-10444",
    price: "256,00 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/11349-tubular-ipc-hfw2841s-s-8mp-28mm-ir30m-wdr-wsense-dahua-6923172581242.html",
    image: "https://conteragroup.pt/2584-medium_default/tubular-ipc-hfw2841s-s-8mp-28mm-ir30m-wdr-wsense-dahua.jpg",
    type: "Tubular",
    megapixels: 8,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10355",
    brand: "DAHUA",
    model: "IPC-HDW3841EM-S-S2",
    fullName: "Dome IPC-HDW3841EM-S-S2 8MP 2.8mm IR30M WSENSE DAHUA",
    ref: "VDDH-10355",
    price: "362,83 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11302-dome-ipc-hdw3841em-s-s2-8mp-28mm-ir30m-poe-ip67-wsense-6923172541437.html",
    image: "https://conteragroup.pt/2542-medium_default/dome-ipc-hdw3841em-s-s2-8mp-28mm-ir30m-poe-ip67-wsense.jpg",
    type: "Dome",
    megapixels: 8,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10538",
    brand: "DAHUA",
    model: "IPC-HDW5442TM-ASE",
    fullName: "Dome IPC-HDW5442TM-ASE IP 4MP 2.8mm IR40M WMIND DAHUA",
    ref: "VDDH-10538",
    price: "298,90 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11619-dome-ipc-hdw5442t-s3-a-4mp-28mm-ir40m-ip67-poe-wmind-6923172588166.html",
    image: "https://conteragroup.pt/3046-medium_default/dome-ipc-hdw5442t-s3-a-4mp-28mm-ir40m-ip67-poe-wmind.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 40,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10513",
    brand: "DAHUA",
    model: "IPC-HDW2841T-ZS",
    fullName: "Dome IPC-HDW2841T-ZS 8MP MTZ 2.7-13.5mm IR40M WSENSE DAHUA",
    ref: "VDDH-10513",
    price: "412,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11811-dome-ipc-hdw2841t-zs-8mp-mtz-27-135mm-ir40m-ip67-wsense-6923172581495.html",
    image: "https://conteragroup.pt/2943-medium_default/dome-ipc-hdw2841t-zs-8mp-mtz-27-135mm-ir40m-ip67-wsense.jpg",
    type: "Dome",
    megapixels: 8,
    lensMotorized: "2.7-13.5mm",
    lensType: "Motorizada",
    irRange: 40,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10197",
    brand: "DAHUA",
    model: "IPC-HFW2541T-ZS",
    fullName: "Tubular IPC-HFW2541T-ZS 5MP MTZ 2.7-13.5mm IR60 WSENSE DAHUA",
    ref: "VDDH-10197",
    price: "296,00 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/11219-tubular-ipc-hfw2541t-zs-5mp-mtz-27-135mm-ir60m-wsense-dahu-6923172582218.html",
    image: "https://conteragroup.pt/2461-medium_default/tubular-ipc-hfw2541t-zs-5mp-mtz-27-135mm-ir60m-wsense-dahu.jpg",
    type: "Tubular",
    megapixels: 5,
    lensMotorized: "2.7-13.5mm",
    lensType: "Motorizada",
    irRange: 60,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10769",
    brand: "DAHUA",
    model: "SD4E425GB-HNR-A-PV1",
    fullName: "PTZ SD4E425GB-HNR-A-PV1 IP 4MP 25x 5-125mm IP67 WSENSE TiOC",
    ref: "VDDH-10769",
    price: "339,15 €",
    link: "https://conteragroup.pt/camaras-ip-speed-domes/13464-ptz-sd4e425gb-hnr-a-pv1-ip-4mp-25x-5-125mm-ip67-wsense-tioc-6923172509826.html",
    image: "https://conteragroup.pt/4956-medium_default/ptz-sd4e425gb-hnr-a-pv1-ip-4mp-25x-5-125mm-ip67-wsense-tioc.jpg",
    type: "PTZ",
    megapixels: 4,
    lensMotorized: "5-125mm",
    lensType: "Motorizada",
    irRange: 100,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: false,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10781",
    brand: "DAHUA",
    model: "IPC-HDW3849H-ZAS-PV-PRO",
    fullName: "Dome IPC-HDW3849H-ZAS-PV-PRO 8MP MTZ 2.7-12mm IR30M WCOLOR",
    ref: "VDDH-10781",
    price: "648,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/13483-dome-ipc-hdw3849h-zas-pv-pro-8mp-mtz-27-12mm-ir30m-wcolor-6937552406834.html",
    image: "https://conteragroup.pt/4974-medium_default/dome-ipc-hdw3849h-zas-pv-pro-8mp-mtz-27-12mm-ir30m-wcolor.jpg",
    type: "Dome",
    megapixels: 8,
    lensMotorized: "2.7-12mm",
    lensType: "Motorizada",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10352",
    brand: "DAHUA",
    model: "IPC-HDW3441T-ZS-S2",
    fullName: "Dome IPC-HDW3441T-ZS-S2 (A) 4MP MTZ 2.7-13.5mm IR40M WSENSE",
    ref: "VDDH-10352",
    price: "282,94 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11299-dome-ipc-hdw3441t-zs-s2-a-4mp-mtz-27-135mm-ir40m-wsense-6923172542397.html",
    image: "https://conteragroup.pt/2539-medium_default/dome-ipc-hdw3441t-zs-s2-a-4mp-mtz-27-135mm-ir40m-wsense.jpg",
    type: "Dome",
    megapixels: 4,
    lensMotorized: "2.7-13.5mm",
    lensType: "Motorizada",
    irRange: 40,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10678",
    brand: "DAHUA",
    model: "IPC-HDBW3449R-ZS-IL",
    fullName: "Dome IPC-HDBW3449R-ZS-IL 4MP MTZ 2.7-13 IR50 DUAL IK10 WSENS",
    ref: "VDDH-10678",
    price: "362,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/12617-dome-ipc-hdbw3449r-zs-il-4mp-mtz-27-135mm-ir40m-wsense-6939554925788.html",
    image: "https://conteragroup.pt/3962-medium_default/dome-ipc-hdbw3449r-zs-il-4mp-mtz-27-135mm-ir40m-wsense.jpg",
    type: "Dome",
    megapixels: 4,
    lensMotorized: "2.7-13.5mm",
    lensType: "Motorizada",
    irRange: 40,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: true,
    hasAI: true,
    hasIK10: true,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10679",
    brand: "DAHUA",
    model: "IPC-HDBW3449E-AS-IL",
    fullName: "Dome IPC-HDBW3449E-AS-IL 4MP 2.8mm IR40M DUAL IK10 WSENSE",
    ref: "VDDH-10679",
    price: "94,35 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/12618-dome-ipc-hdbw3449r-as-il-4mp-28mm-ir40m-ip67-wsense-dahua-6939554920592.html",
    image: "https://conteragroup.pt/3953-medium_default/dome-ipc-hdbw3449r-as-il-4mp-28mm-ir40m-ip67-wsense-dahua.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 40,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: true,
    hasAI: true,
    hasIK10: true,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10712",
    brand: "DAHUA",
    model: "IPC-HFW3649T1-AS-PV-PRO",
    fullName: "Tubular IPC-HFW3649T1-AS-PV-PRO 6MP 2.8mm IR50M PRO TIOC",
    ref: "VDDH-10712",
    price: "436,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/13011-tubular-ipc-hfw3649t1-as-pv-pro-6mp-28mm-ir30m-pro-tioc-6923172592323.html",
    image: "https://conteragroup.pt/4422-medium_default/tubular-ipc-hfw3649t1-as-pv-pro-6mp-28mm-ir30m-pro-tioc.jpg",
    type: "Tubular",
    megapixels: 6,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 50,
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10486",
    brand: "DAHUA",
    model: "IPC-HFW2241S-S",
    fullName: "Tubular IPC-HFW2241S-S IP 2MP 2.8mm IR30M WSENSE DAHUA",
    ref: "VDDH-10486",
    price: "138,00 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/11368-tubular-ipc-hfw2241s-s-ip-2mp-28mm-ir30m-wsense-dahua-6923172539816.html",
    image: "https://conteragroup.pt/2597-medium_default/tubular-ipc-hfw2241s-s-ip-2mp-28mm-ir30m-wsense-dahua.jpg",
    type: "Tubular",
    megapixels: 2,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10787",
    brand: "DAHUA",
    model: "IPC-HDBW5459E1-ZE-IL",
    fullName: "Dome IPC-HDBW5459E1-ZE-IL 4MP MTZ 2.7-12mm IR50M IK10 WMIND",
    ref: "VDDH-10787",
    price: "576,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/13489-dome-ipc-hdbw5459e1-ze-il-4mp-mtz-27-12mm-ir50m-ik10-wmind-6937552412491.html",
    image: "https://conteragroup.pt/4980-medium_default/dome-ipc-hdbw5459e1-ze-il-4mp-mtz-27-12mm-ir50m-ik10-wmind.jpg",
    type: "Dome",
    megapixels: 4,
    lensMotorized: "2.7-12mm",
    lensType: "Motorizada",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: true,
    hasAI: true,
    hasIK10: true,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10691",
    brand: "DAHUA",
    model: "IPC-HFW3849T-AS-PV-S5",
    fullName: "Tubular IPC-HFW3849T-AS-PV-S5 8MP 2.8mm IR30M TIOC 3.0 DAHUA",
    ref: "VDDH-10691",
    price: "442,00 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/12963-tubular-ipc-hfw3849t-as-pv-s5-8mp-28mm-ir30m-tioc-30-dahua-6923172525512.html",
    image: "https://conteragroup.pt/4371-medium_default/tubular-ipc-hfw3849t-as-pv-s5-8mp-28mm-ir30m-tioc-30-dahua.jpg",
    type: "Tubular",
    megapixels: 8,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10748",
    brand: "DAHUA",
    model: "IPC-HFW3849T1-AS-PV-PRO",
    fullName: "Tubular IPC-HFW3849T1-AS-PV-PRO 8MP 2.8mm IR50M TiOC",
    ref: "VDDH-10748",
    price: "510,00 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/13111-tubular-ipc-hfw3849t1-as-pv-pro-8mp-28mm-ir30m-tioc-6923172570918.html",
    image: "https://conteragroup.pt/4597-medium_default/tubular-ipc-hfw3849t1-as-pv-pro-8mp-28mm-ir30m-tioc.jpg",
    type: "Tubular",
    megapixels: 8,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10580",
    brand: "DAHUA",
    model: "Dome",
    fullName: "Dome Térmica TPC-DF1241-B7F8-DW-S8 4MP 8mm IR30M DAHUA",
    ref: "VDDH-10580",
    price: "716,00 €",
    link: "https://conteragroup.pt/camaras-tpc-termicas/12025-dome-termica-tpc-df1241-b7f8-dw-s2-4mp-8mm-ir30m-dahua.html",
    image: "https://conteragroup.pt/3547-medium_default/dome-termica-tpc-df1241-b7f8-dw-s2-4mp-8mm-ir30m-dahua.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "DWDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: false,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10722",
    brand: "DAHUA",
    model: "IPC-HFW3449T1-AS-PV-PRO",
    fullName: "Tubular IPC-HFW3449T1-AS-PV-PRO 4MP MTZ IR50M WIZCOLOR TIOC",
    ref: "VDDH-10722",
    price: "402,00 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/13035-tubular-ipc-hfw3449t1-as-pv-pro-4mp-mtz-ir50m-wizcolor-tioc-6923172568960.html",
    image: "https://conteragroup.pt/4454-medium_default/tubular-ipc-hfw3449t1-as-pv-pro-4mp-mtz-ir50m-wizcolor-tioc.jpg",
    type: "Tubular",
    megapixels: 4,
    lensMotorized: "2.7-13.5mm",
    lensType: "Motorizada",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10276",
    brand: "DAHUA",
    model: "IPC-HFW3849T1-ZAS-PV",
    fullName: "Tubular IPC-HFW3849T1-ZAS-PV 8MP MTZ 2.7-13.5 IR50M TIOC 2.0",
    ref: "VDDH-10276",
    price: "644,00 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/11255-tubular-ipc-hfw3849t1-zas-pv-8mp-mtz-27-135-ir50m-tioc-20-6923172502766.html",
    image: "https://conteragroup.pt/2497-medium_default/tubular-ipc-hfw3849t1-zas-pv-8mp-mtz-27-135-ir50m-tioc-20.jpg",
    type: "Tubular",
    megapixels: 8,
    lensMotorized: "2.7-13.5mm",
    lensType: "Motorizada",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10322",
    brand: "DAHUA",
    model: "IPC-HFW5842T-ASE-S2",
    fullName: "Tubular IPC-HFW5842T-ASE-S2 8MP 2.8mm IR50M IK10 WMIND DAHUA",
    ref: "VDDH-10322",
    price: "395,53 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/11282-tubular-ipc-hfw5842t-ase-s2-8mp-28mm-ir50m-ik10-wmind-dahua-6923172524805.html",
    image: "https://conteragroup.pt/2523-medium_default/tubular-ipc-hfw5842t-ase-s2-8mp-28mm-ir50m-ik10-wmind-dahua.jpg",
    type: "Tubular",
    megapixels: 8,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: true,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10625",
    brand: "DAHUA",
    model: "SD4A225DB-HNY",
    fullName: "PTZ SD4A225DB-HNY 2MP 25x IR100M TRCK (S/SUPORTE) WSENSE",
    ref: "VDDH-10625",
    price: "282,20 €",
    link: "https://conteragroup.pt/camaras-ip-speed-domes/12139-ptz-sd4a225db-hny-2mp-48-120mm-25x-ir100m-ip66-wsense-6923172569615.html",
    image: "https://conteragroup.pt/3440-medium_default/ptz-sd4a225db-hny-2mp-48-120mm-25x-ir100m-ip66-wsense.jpg",
    type: "PTZ",
    megapixels: 2,
    lensMotorized: "4.8-120mm",
    lensType: "Motorizada",
    irRange: 100,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: false,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-00875",
    brand: "DAHUA",
    model: "IPC-HDW2231TM-AS-S2",
    fullName: "Dome IPC-HDW2231TM-AS-S2 2MP 2.8mm WDR STRL IR30M DAHUA",
    ref: "VDDH-00875",
    price: "139,93 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/13557-dome-ipc-hdw2231tm-as-s2-2mp-28mm-wdr-strl-ir30m-dahua-6923172520180.html",
    image: "https://conteragroup.pt/5070-medium_default/dome-ipc-hdw2231tm-as-s2-2mp-28mm-wdr-strl-ir30m-dahua.jpg",
    type: "Dome",
    megapixels: 2,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10683",
    brand: "DAHUA",
    model: "IPC-HDW3449H-ZAS-PV-B",
    fullName: "Dome IPC-HDW3449H-ZAS-PV-B PRETA 4MP 2.7-13mm MTZ IR50M TIOC",
    ref: "VDDH-10683",
    price: "418,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/12698-dome-ipc-hdw3449h-zas-pv-b-4mp-27-135mm-mtz-ir50m-wsense.html",
    image: "https://conteragroup.pt/4138-medium_default/dome-ipc-hdw3449h-zas-pv-b-4mp-27-135mm-mtz-ir50m-wsense.jpg",
    type: "Dome",
    megapixels: 4,
    lensMotorized: "2.7-13.5mm",
    lensType: "Motorizada",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10408",
    brand: "DAHUA",
    model: "IPC-HFW3441T-AS-P",
    fullName: "FISHEYE TUBULAR IPC-HFW3441T-AS-P 4MP 2.1mm IR20M WSENSE DAH",
    ref: "VDDH-10408",
    price: "340,00 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/11334-tubular-ipc-hfw3441t-as-p-4mp-21mm-ir20m-wsense-dahua-6923172540041.html",
    image: "https://conteragroup.pt/2573-medium_default/tubular-ipc-hfw3441t-as-p-4mp-21mm-ir20m-wsense-dahua.jpg",
    type: "Fisheye",
    megapixels: 4,
    lensFixed: "2.1mm",
    lensType: "Fixa",
    irRange: 20,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10671",
    brand: "DAHUA",
    model: "SD49825GB-HNR",
    fullName: "PTZ SD49825GB-HNR IP 8MP 25x IR100M WSENSE DAHUA",
    ref: "VDDH-10671",
    price: "384,20 €",
    link: "https://conteragroup.pt/camaras-ip-speed-domes/12611-ptz-sd49825gb-hnr-ip-8mp-25x-5125mm-ir100m-ip66-wsense-6923172587510.html",
    image: "https://conteragroup.pt/3956-medium_default/ptz-sd49825gb-hnr-ip-8mp-25x-5125mm-ir100m-ip66-wsense.jpg",
    type: "PTZ",
    megapixels: 8,
    lensMotorized: "5-125mm",
    lensType: "Motorizada",
    irRange: 100,
    wdrType: "DWDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: false,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10173",
    brand: "DAHUA",
    model: "IPC-HDBW2431E-S-S2",
    fullName: "Dome IPC-HDBW2431E-S-S2 4MP 2.8mm IR30M WDR STRL IK10 DAHUA",
    ref: "VDDH-10173",
    price: "152,45 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11202-dome-ipc-hdbw2431e-s-s2-4mp-28mm-ir30m-wdr-strl-ik10-dahua-6939554977251.html",
    image: "https://conteragroup.pt/2445-medium_default/dome-ipc-hdbw2431e-s-s2-4mp-28mm-ir30m-wdr-strl-ik10-dahua.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: true,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10488",
    brand: "DAHUA",
    model: "IPC-HDBW2441E-S",
    fullName: "Dome IPC-HDBW2441E-S 4MP 3.6mm IR30M IK10 WSENSE DAHUA",
    ref: "VDDH-10488",
    price: "154,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11370-dome-ipc-hdbw2441e-s-4mp-36mm-ir30m-ik10-wsense-dahua-6923172546746.html",
    image: "https://conteragroup.pt/2599-medium_default/dome-ipc-hdbw2441e-s-4mp-36mm-ir30m-ik10-wsense-dahua.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "3.6mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: true,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10768",
    brand: "DAHUA",
    model: "SD4D425MB-HNR",
    fullName: "PTZ SD4D425MB-HNR IP 4MP 25x IR100M DUAL WSENSE DAHUA",
    ref: "VDDH-10768",
    price: "340,00 €",
    link: "https://conteragroup.pt/camaras-ip-speed-domes/13463-ptz-sd4d425mb-hnr-ip-4mp-25x-ir100m-dual-wsense-dahua-6939554962479.html",
    image: "https://conteragroup.pt/4955-medium_default/ptz-sd4d425mb-hnr-ip-4mp-25x-ir100m-dual-wsense-dahua.jpg",
    type: "PTZ",
    megapixels: 4,
    lensMotorized: "5-125mm",
    lensType: "Motorizada",
    irRange: 100,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: false,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10400",
    brand: "DAHUA",
    model: "SD22404DB-GNY-W",
    fullName: "Dome PTZ SD22404DB-GNY-W IP 4MP 4x 2.8-12mm WIFI IK10 WSENSE",
    ref: "VDDH-10400",
    price: "141,10 €",
    link: "https://conteragroup.pt/camaras-ip-speed-domes/11331-dome-ptz-sd22404db-gny-w-ip-4mp-4x-28-12mm-wifi-ik10-wsense-6923172536402.html",
    image: "https://conteragroup.pt/2570-medium_default/dome-ptz-sd22404db-gny-w-ip-4mp-4x-28-12mm-wifi-ik10-wsense.jpg",
    type: "PTZ",
    megapixels: 4,
    lensMotorized: "2.8-12mm",
    lensType: "Motorizada",
    irRange: 0,
    wdrType: "DWDR",
    hasWifi: true,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: true,
    hasPOE: false,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10353",
    brand: "DAHUA",
    model: "IPC-HFW3841E-S-S2",
    fullName: "Tubular IPC-HFW3841E-S-S2 8MP 2.8mm IR30M WSENSE DAHUA",
    ref: "VDDH-10353",
    price: "320,00 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/11300-tubular-ipc-hfw3841e-s-s2-8mp-28mm-ir30m-wsense-dahua-6923172542236.html",
    image: "https://conteragroup.pt/2540-medium_default/tubular-ipc-hfw3841e-s-s2-8mp-28mm-ir30m-wsense-dahua.jpg",
    type: "Tubular",
    megapixels: 8,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10001",
    brand: "DAHUA",
    model: "IPC-HFW2231S-S-S2-QH",
    fullName: "Tubular IPC-HFW2231S-S-S2-QH 2MP 3.6mm IR30M DAHUA",
    ref: "VDDH-10001",
    price: "120,67 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/11104-tubular-ipc-hfw2231s-s-s2-qh-2mp-36mm-ir30m-dahua-6923172520166.html",
    image: "https://conteragroup.pt/2347-medium_default/tubular-ipc-hfw2231s-s-s2-qh-2mp-36mm-ir30m-dahua.jpg",
    type: "Tubular",
    megapixels: 2,
    lensFixed: "3.6mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10289",
    brand: "DAHUA",
    model: "MPT220",
    fullName: "MPT220 - Body Camara 2MP 16GB 2.0\" IR5M Android DAHUA",
    ref: "VDDH-10289",
    price: "686,55 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/13146-mpt220-body-camara-2mp-16gb-20-ir5m-android-dahua-6923172509819.html",
    type: "Dome",
    megapixels: 2,
    lensType: "Fixa",
    irRange: 5,
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: false,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10354",
    brand: "DAHUA",
    model: "IPC-HDW3841T-ZS-S2",
    fullName: "Dome IPC-HDW3841T-ZS-S2 8MP MTZ 2.7-13.5mm IR40M WSENSE",
    ref: "VDDH-10354",
    price: "495,15 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11301-dome-ipc-hdw3841t-zs-s2-8mp-mtz-27-135mm-ir40m-wsense-6923172542410.html",
    image: "https://conteragroup.pt/2541-medium_default/dome-ipc-hdw3841t-zs-s2-8mp-mtz-27-135mm-ir40m-wsense.jpg",
    type: "Dome",
    megapixels: 8,
    lensMotorized: "2.7-13.5mm",
    lensType: "Motorizada",
    irRange: 40,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-00657",
    brand: "DAHUA",
    model: "IPC-HDBW7442H-Z-S2",
    fullName: "Dome IPC-HDBW7442H-Z-S2 4MP Mtz 2.7-12mm IR40M ePoE WMIND DA",
    ref: "VDDH-00657",
    price: "962,26 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/10915-dome-ipc-hdbw7442hp-z-4mp-mtz-27-12mm-ir40m-epoe-wmind-dahu-6939554968457.html",
    image: "https://conteragroup.pt/2965-medium_default/dome-ipc-hdbw7442hp-z-4mp-mtz-27-12mm-ir40m-epoe-wmind-dahu.jpg",
    type: "Dome",
    megapixels: 4,
    lensMotorized: "2.7-12mm",
    lensType: "Motorizada",
    irRange: 40,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10381",
    brand: "DAHUA",
    model: "IPC-HDBW2441E-S-B",
    fullName: "Dome IPC-HDBW2441E-S-B PRETA 4MP 2.8mm IR30M IK10 WSENSE",
    ref: "VDDH-10381",
    price: "162,27 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11794-dome-ipc-hdbw2441e-s-b-4mp-28mm-ir30m-ik10-preta-wsense-6923172565945.html",
    image: "https://conteragroup.pt/2942-medium_default/dome-ipc-hdbw2441e-s-b-4mp-28mm-ir30m-ik10-preta-wsense.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: true,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10168",
    brand: "DAHUA",
    model: "ITC413-PW4D-IZ3",
    fullName: "LPR Tubular ITC413-PW4D-IZ3 IP 4MP 8-32mm IR30M DAHUA",
    ref: "VDDH-10168",
    price: "510,85 €",
    link: "https://conteragroup.pt/camaras-anpr/12684-lpr-tubular-itc413-pw4d-iz3-ip-4mp-8-32mm-ir30m-dahua-6923172581419.html",
    image: "https://conteragroup.pt/4075-medium_default/lpr-tubular-itc413-pw4d-iz3-ip-4mp-8-32mm-ir30m-dahua.jpg",
    type: "Tubular",
    megapixels: 4,
    lensMotorized: "8-32mm",
    lensType: "Motorizada",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: false,
    detPeople: false,
    detVehicle: false,
    hasLPR: true,
  },
  {
    id: "dahua-VDDH-10370",
    brand: "DAHUA",
    model: "IPC-HDW3849H-AS-PV-S4-B",
    fullName: "Dome IPC-HDW3849H-AS-PV-S4-B PRETA 8MP 2.8mm IR30M TIOC 2.0",
    ref: "VDDH-10370",
    price: "382,80 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11789-dome-ipc-hdw3849h-as-pv-s4-8mp-28mm-ir30m-preta-tioc-20.html",
    image: "https://conteragroup.pt/2946-medium_default/dome-ipc-hdw3849h-as-pv-s4-8mp-28mm-ir30m-preta-tioc-20.jpg",
    type: "Dome",
    megapixels: 8,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10681",
    brand: "DAHUA",
    model: "IPC-HFW3549T1-AS-PV-S5-B",
    fullName: "Tubular IPC-HFW3549T1-AS-PV-S5-B PRETA 5MP 2.8 IR30 TIOC",
    ref: "VDDH-10681",
    price: "375,00 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/12644-tubular-ipc-hfw3549t1-as-pv-s5-b-5mp-28mm-ir30m-acupick-tio.html",
    type: "Tubular",
    megapixels: 5,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10341",
    brand: "DAHUA",
    model: "IPC-HDBW3449E-AS-NI",
    fullName: "Dome IPC-HDBW3449E-AS-NI 4MP 2.8mm (S/IR) IK10 FCOLOR WSENSE",
    ref: "VDDH-10341",
    price: "224,54 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11292-dome-ipc-hdbw3449e-as-ni-4mp-28mm-poe-ip67-ik10-wsense-6939554987809.html",
    image: "https://conteragroup.pt/2532-medium_default/dome-ipc-hdbw3449e-as-ni-4mp-28mm-poe-ip67-ik10-wsense.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: false,
    hasAI: true,
    hasIK10: true,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10711",
    brand: "DAHUA",
    model: "IPC-HFW7442H-Z-S2",
    fullName: "Tubular IPC-HFW7442H-Z-S2 4MP MTZ 2.7-12mm IR60 IK10 WIZMIND",
    ref: "VDDH-10711",
    price: "889,41 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/13101-tubular-ipc-hfw7442h-z-s2-4mp-mtz-27-12mm-ir60-ik10-wizmind.html",
    image: "https://conteragroup.pt/4553-medium_default/tubular-ipc-hfw7442h-z-s2-4mp-mtz-27-12mm-ir60-ik10-wizmind.jpg",
    type: "Tubular",
    megapixels: 4,
    lensMotorized: "2.7-12mm",
    lensType: "Motorizada",
    irRange: 60,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: true,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10782",
    brand: "DAHUA",
    model: "IPC-HDW5459T-ZE-IL",
    fullName: "Dome IPC-HDW5459T-ZE-IL 4MP MTZ 2.7-12mm IR50M WMIND",
    ref: "VDDH-10782",
    price: "570,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/13484-dome-ipc-hdw5459t-ze-il-4mp-mtz-27-12mm-ir50m-wmind-6937552412118.html",
    type: "Dome",
    megapixels: 4,
    lensMotorized: "2.7-12mm",
    lensType: "Motorizada",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10793",
    brand: "DAHUA",
    model: "SDT6C425-4P-GB-APV",
    fullName: "PTZ SDT6C425-4P-GB-APV IP 4MP 2.8mm 25x PANORÂMICA IP66",
    ref: "VDDH-10793",
    price: "1473,88 €",
    link: "https://conteragroup.pt/camaras-ip-speed-domes/13493-ptz-sdt6c425-4p-gb-apv-ip-4mp-28mm-25x-panoramica-ip66-6923172587855.html",
    image: "https://conteragroup.pt/5013-medium_default/ptz-sdt6c425-4p-gb-apv-ip-4mp-28mm-25x-panoramica-ip66.jpg",
    type: "PTZ",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: false,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-00688",
    brand: "DAHUA",
    model: "IPC-HFW2239S-SA-LED-S2",
    fullName: "Tubular IPC-HFW2239S-SA-LED-S2 IP 2MP 3.6mm IR30M FULL COLOR",
    ref: "VDDH-00688",
    price: "133,91 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/10932-tubular-ipc-hfw2239s-sa-led-s2-ip-2mp-36mm-ir30m-full-color-6939554990434.html",
    image: "https://conteragroup.pt/3627-medium_default/tubular-ipc-hfw2239s-sa-led-s2-ip-2mp-36mm-ir30m-full-color.jpg",
    type: "Tubular",
    megapixels: 2,
    lensFixed: "3.6mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-00146",
    brand: "DAHUA",
    model: "SD42212T-HN-S2",
    fullName: "PTZ SD42212T-HN-S2 IP 2MP 12X STRL PoE+ IK10 IP66 DAHUA",
    ref: "VDDH-00146",
    price: "229,16 €",
    link: "https://conteragroup.pt/camaras-ip-speed-domes/10753-ptz-sd42212t-hn-s2-ip-2mp-12x-strl-poe--ik10-ip66-dahua-6939554932281.html",
    image: "https://conteragroup.pt/1996-medium_default/ptz-sd42212t-hn-s2-ip-2mp-12x-strl-poe--ik10-ip66-dahua.jpg",
    type: "PTZ",
    megapixels: 2,
    lensMotorized: "5.3-64mm",
    lensType: "Motorizada",
    irRange: 0,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: true,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10794",
    brand: "DAHUA",
    model: "SDT4E225-4F-GB-A-PV1-S2",
    fullName: "PTZ SDT4E225-4F-GB-A-PV1-S2 IP 2+4MP 25x IR100M X-SPANS",
    ref: "VDDH-10794",
    price: "828,00 €",
    link: "https://conteragroup.pt/camaras-ip-speed-domes/13494-ptz-sdt4e225-4f-gb-a-pv1-s2-ip-24mp-25x-ir100m-x-spans-6937552412392.html",
    image: "https://conteragroup.pt/4983-medium_default/ptz-sdt4e225-4f-gb-a-pv1-s2-ip-24mp-25x-ir100m-x-spans.jpg",
    type: "PTZ",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 100,
    wdrType: "DWDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: false,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10356",
    brand: "DAHUA",
    model: "IPC-HDBW3841R-ZS-S2",
    fullName: "Dome IPC-HDBW3841R-ZS-S2 8MP MTZ 2.7-13.5mm IR40 IK10 WSENSE",
    ref: "VDDH-10356",
    price: "492,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11303-dome-ipc-hdbw3841r-zs-s2-8mp-mtz-27-135mm-ir40m-ik10-wsens-6923172542366.html",
    image: "https://conteragroup.pt/2543-medium_default/dome-ipc-hdbw3841r-zs-s2-8mp-mtz-27-135mm-ir40m-ik10-wsens.jpg",
    type: "Dome",
    megapixels: 8,
    lensMotorized: "2.7-13.5mm",
    lensType: "Motorizada",
    irRange: 40,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: true,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-00653",
    brand: "DAHUA",
    model: "IPC-HFW2431S-S-S2",
    fullName: "Tubular IPC-HFW2431S-S-S2 4MP 2.8mm WDR STRL IR30M DAHUA",
    ref: "VDDH-00653",
    price: "142,14 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/10912-tubular-ipc-hfw2431s-s-s2-4mp-28mm-wdr-strl-ir30m-dahua-6939554975769.html",
    image: "https://conteragroup.pt/3036-medium_default/tubular-ipc-hfw2431s-s-s2-4mp-28mm-wdr-strl-ir30m-dahua.jpg",
    type: "Tubular",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10685",
    brand: "DAHUA",
    model: "SD5A825GA-HNR",
    fullName: "PTZ SD5A825GA-HNR IP 8MP 25x 5.4–135mm IR150M WSENSE DAHUA",
    ref: "VDDH-10685",
    price: "718,25 €",
    link: "https://conteragroup.pt/camaras-ip-speed-domes/12957-ptz-sd5a825ga-hnr-ip-8mp-25x-54135mm-ir150m-wsense-dahua-6923172545688.html",
    image: "https://conteragroup.pt/4365-medium_default/ptz-sd5a825ga-hnr-ip-8mp-25x-54135mm-ir150m-wsense-dahua.jpg",
    type: "PTZ",
    megapixels: 8,
    lensMotorized: "5.4-135mm",
    lensType: "Motorizada",
    irRange: 150,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: false,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10795",
    brand: "DAHUA",
    model: "SDW81652S-A360-D440",
    fullName: "PTZ PSDW81652S-A360-D440 16MP MULTI-SENSOR 360° IR100M",
    ref: "VDDH-10795",
    price: "5497,41 €",
    link: "https://conteragroup.pt/camaras-ip-speed-domes/13495-ptz-psdw81652s-a360-d440-16mp-multi-sensor-360-ir100m-6937552406308.html",
    image: "https://conteragroup.pt/5012-medium_default/ptz-psdw81652s-a360-d440-16mp-multi-sensor-360-ir100m.jpg",
    type: "PTZ",
    megapixels: 16,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 100,
    wdrType: "DWDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: false,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10692",
    brand: "DAHUA",
    model: "IPC-HFW3449E-AS-IL",
    fullName: "Tubular IPC-HFW3449E-AS-IL 4MP 2.8mm IR50M DUAL WSENSE",
    ref: "VDDH-10692",
    price: "236,00 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/12964-tubular-ipc-hfw3449e-as-il-4mp-28mm-ir50m-dual-light-wsense-6939554924798.html",
    image: "https://conteragroup.pt/4372-medium_default/tubular-ipc-hfw3449e-as-il-4mp-28mm-ir50m-dual-light-wsense.jpg",
    type: "Tubular",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10828",
    brand: "DAHUA",
    model: "IPC-HDBW3541F-AS-S2",
    fullName: "Dome IPC-HDBW3541F-AS-S2 5MP 2.8mm IR30M IK10 WSENSE DAHUA",
    ref: "VDDH-10828",
    price: "250,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/13548-dome-ipc-hdbw3541f-as-s2-5mp-28mm-ir30m-ik10-wsense-dahua.html",
    image: "https://conteragroup.pt/5060-medium_default/dome-ipc-hdbw3541f-as-s2-5mp-28mm-ir30m-ik10-wsense-dahua.jpg",
    type: "Dome",
    megapixels: 5,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: true,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10729",
    brand: "DAHUA",
    model: "IPC-HFW3649T1-AS-PV-PRO",
    fullName: "Tubular IPC-HFW3649T1-AS-PV-PRO 6MP 3.6mm IR50M TiOC PRO",
    ref: "VDDH-10729",
    price: "388,00 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/13107-tubular-ipc-hfw3649t1-as-pv-pro-6mp-36mm-ir50m-tioc-pro-6939554914201.html",
    image: "https://conteragroup.pt/4557-medium_default/tubular-ipc-hfw3649t1-as-pv-pro-6mp-36mm-ir50m-tioc-pro.jpg",
    type: "Tubular",
    megapixels: 6,
    lensFixed: "3.6mm",
    lensType: "Fixa",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10816",
    brand: "DAHUA",
    model: "IPC-HDW5442T-ZE-B",
    fullName: "Dome IPC-HDW5442T-ZE-B 4MP MTZ 2.7-12mm IR40M WMIND DAHUA",
    ref: "VDDH-10816",
    price: "499,50 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/13387-dome-ipc-hdw5442t-ze-b-4mp-mtz-27-12mm-ir40m-wmind-dahua.html",
    image: "https://conteragroup.pt/5018-medium_default/dome-ipc-hdw5442t-ze-b-4mp-mtz-27-12mm-ir40m-wmind-dahua.jpg",
    type: "Dome",
    megapixels: 4,
    lensMotorized: "2.7-12mm",
    lensType: "Motorizada",
    irRange: 40,
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10690",
    brand: "DAHUA",
    model: "IPC-HDW3849H-AS-PV-S5",
    fullName: "Dome IPC-HDW3849H-AS-PV-S5 8MP 2.8mm IR30M TIOC 3.0 DAHUA",
    ref: "VDDH-10690",
    price: "460,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/12962-dome-ipc-hdw3849h-as-pv-s5-8mp-28mm-ir30m-tioc-30-dahua-6923172525765.html",
    image: "https://conteragroup.pt/4370-medium_default/dome-ipc-hdw3849h-as-pv-s5-8mp-28mm-ir30m-tioc-30-dahua.jpg",
    type: "Dome",
    megapixels: 8,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-00123",
    brand: "DAHUA",
    model: "KB1000",
    fullName: "KB1000 - MESA CONTROLO PARA PTZ RS422/USB DAHUA",
    ref: "VDDH-00123",
    price: "114,06 €",
    link: "https://conteragroup.pt/camaras-ip-speed-domes/10747-kb1000---teclado-3-eixos-para-ptz-rs422usb-dahua-5600341676886.html",
    image: "https://conteragroup.pt/1990-medium_default/kb1000---teclado-3-eixos-para-ptz-rs422usb-dahua.jpg",
    type: "PTZ",
    megapixels: 0,
    lensType: "Fixa",
    irRange: 0,
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: false,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10116",
    brand: "DAHUA",
    model: "Dome",
    fullName: "Dome HY-SAV849HA-E Sensor Fumo 5MP 2mm AI IR20M DAHUA",
    ref: "VDDH-10116",
    price: "185,66 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11175-dome-hy-sav849ha-e-sensor-fumo-5mp-2mm-ai-ir20m-dahua-6923172532657.html",
    image: "https://conteragroup.pt/2418-medium_default/dome-hy-sav849ha-e-sensor-fumo-5mp-2mm-ai-ir20m-dahua.jpg",
    type: "Dome",
    megapixels: 5,
    lensFixed: "2.0mm",
    lensType: "Fixa",
    irRange: 20,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: false,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-00618",
    brand: "DAHUA",
    model: "IPC-HDBW5442RP-ASE",
    fullName: "Dome IPC-HDBW5442RP-ASE 4MP 2.8mm IR50M WMIND DAHUA",
    ref: "VDDH-00618",
    price: "288,14 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/10888-dome-ipc-hdbw5442rp-ase-4mp-28mm-ir50m-wmind-dahua-6939554969201.html",
    image: "https://conteragroup.pt/2957-medium_default/dome-ipc-hdbw5442rp-ase-4mp-28mm-ir50m-wmind-dahua.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-00621",
    brand: "DAHUA",
    model: "IPC-HFW2531SP-S-S2",
    fullName: "Tubular IPC-HFW2531SP-S-S2 5MP 2.8mm IR30M WDR STRL DAHUA",
    ref: "VDDH-00621",
    price: "170,85 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/10891-tubular-ipc-hfw2531sp-s-s2-5mp-28mm-ir30m-wdr-strl-dahua-6939554978128.html",
    image: "https://conteragroup.pt/2958-medium_default/tubular-ipc-hfw2531sp-s-s2-5mp-28mm-ir30m-wdr-strl-dahua.jpg",
    type: "Tubular",
    megapixels: 5,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-00706",
    brand: "DAHUA",
    model: "IPC-HDBW5442H-ZE",
    fullName: "Dome IPC-HDBW5442H-ZE 4MP 2.7-12mm Mtz IR40M ePoE WMIND DAHU",
    ref: "VDDH-00706",
    price: "480,33 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/10939-dome-ipc-hdbw5442h-ze-4mp-27-12mm-mtrz-ir40m-epoe-wmind-6939554993503.html",
    image: "https://conteragroup.pt/2970-medium_default/dome-ipc-hdbw5442h-ze-4mp-27-12mm-mtrz-ir40m-epoe-wmind.jpg",
    type: "Dome",
    megapixels: 4,
    lensMotorized: "2.7-12mm",
    lensType: "Motorizada",
    irRange: 40,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-66451",
    brand: "DAHUA",
    model: "IPC-HDW3441T-ZAS",
    fullName: "Dome IPC-HDW3441T-ZAS 4MP Mtr 2.7-13.5mm IR40M WSENSE DAHUA",
    ref: "VDDH-66451",
    price: "273,70 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11385-dome-ipc-hdw3441t-zas-4mp-mtr-27-135mm-ir40m-wsense-dahua-6939554978029.html",
    image: "https://conteragroup.pt/2614-medium_default/dome-ipc-hdw3441t-zas-4mp-mtr-27-135mm-ir40m-wsense-dahua.jpg",
    type: "Dome",
    megapixels: 4,
    lensMotorized: "2.7-13.5mm",
    lensType: "Motorizada",
    irRange: 40,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-00999",
    brand: "DAHUA",
    model: "IPC-EBW81242-AS-S2",
    fullName: "Fisheye IPC-EBW81242-AS-S2 IP 12MP IR10M WMIND DAHUA",
    ref: "VDDH-00999",
    price: "1468,80 €",
    link: "https://conteragroup.pt/camaras-ipc-fisheye/11099-fisheye-ipc-ebw81242-as-s2-ip-12mp-ir10m-wmind-dahua-6923172507631.html",
    image: "https://conteragroup.pt/2342-medium_default/fisheye-ipc-ebw81242-as-s2-ip-12mp-ir10m-wmind-dahua.jpg",
    type: "Fisheye",
    megapixels: 12,
    lensFixed: "1.3mm",
    lensType: "Fixa",
    irRange: 10,
    wdrType: "DWDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10448",
    brand: "DAHUA",
    model: "IPC-HDBW2541R-ZS",
    fullName: "Dome IPC-HDBW2541R-ZS 5MP MTZ 2.7-13.5mm IR40M IK10 WSENSE",
    ref: "VDDH-10448",
    price: "300,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11353-dome-ipc-hdbw2541r-zs-5mp-mtz-27-135mm-ir40m-ik10-wsense-6923172581730.html",
    image: "https://conteragroup.pt/2588-medium_default/dome-ipc-hdbw2541r-zs-5mp-mtz-27-135mm-ir40m-ik10-wsense.jpg",
    type: "Dome",
    megapixels: 5,
    lensMotorized: "2.7-13.5mm",
    lensType: "Motorizada",
    irRange: 40,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: true,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10521",
    brand: "DAHUA",
    model: "IPC-HUM4431S-L4",
    fullName: "CÂMARA PINHOLE IPC-HUM4431S-L4 IP 4MP 2.8mm - DAHUA",
    ref: "VDDH-10521",
    price: "414,73 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11551-camara-pinhole-ipc-hum4431s-l4-ip-4mp-28mm---dahua-6923172536525.html",
    image: "https://conteragroup.pt/img/p/pt-default-medium_default.jpg",
    type: "Pinhole",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 0,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10474",
    brand: "DAHUA",
    model: "IPC-PDW5849-A180-E2-ASTE",
    fullName: "Dome IPC-PDW5849-A180-E2-ASTE 2x4MP 3.6 180º IR40 F. COLOR",
    ref: "VDDH-10474",
    price: "650,54 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11805-dome-ipc-pdw5849-a180-e2-aste-24mp-36mm-180-ir40m-wmind-6923172585554.html",
    image: "https://conteragroup.pt/2940-medium_default/dome-ipc-pdw5849-a180-e2-aste-24mp-36mm-180-ir40m-wmind.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "3.6mm",
    lensType: "Fixa",
    irRange: 40,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10141",
    brand: "DAHUA",
    model: "IPC-HDW5449H-ASE-D2-QH",
    fullName: "Dome IPC-HDW5449H-ASE-D2-QH 4MP 2.8mm IR50M WMIND FCOLOR",
    ref: "VDDH-10141",
    price: "506,55 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11186-dome-ipc-hdw5449h-ase-d2-qh-4mp-28mm-ir50m-wmind-fcolor-6923172540287.html",
    image: "https://conteragroup.pt/2429-medium_default/dome-ipc-hdw5449h-ase-d2-qh-4mp-28mm-ir50m-wmind-fcolor.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 50,
    wdrType: "DWDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10181",
    brand: "DAHUA",
    model: "IPC-HDW2431T-ZS-S2-B",
    fullName: "Dome IPC-HDW2431T-ZS-S2-B PRETA 4MP Mtz 2.7-13.5mm IR40M DAH",
    ref: "VDDH-10181",
    price: "226,61 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11208-dome-ipc-hdw2431t-zs-s2-b-preta-4mp-mtz-27-135mm-ir40m-dah-6939554976889.html",
    image: "https://conteragroup.pt/2450-medium_default/dome-ipc-hdw2431t-zs-s2-b-preta-4mp-mtz-27-135mm-ir40m-dah.jpg",
    type: "Dome",
    megapixels: 4,
    lensMotorized: "2.7-13.5mm",
    lensType: "Motorizada",
    irRange: 40,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10230",
    brand: "DAHUA",
    model: "SD5A432GB-HNR",
    fullName: "PTZ SD5A432GB-HNR IP 4MP 32x IR150M TRCK IK10 WSENSE DAHUA",
    ref: "VDDH-10230",
    price: "554,20 €",
    link: "https://conteragroup.pt/camaras-ip-speed-domes/11234-ptz-sd5a432gb-hnr-ip-4mp-32x-ir150m-strl-ik10-wsense-dahua-6923172540867.html",
    image: "https://conteragroup.pt/2476-medium_default/ptz-sd5a432gb-hnr-ip-4mp-32x-ir150m-strl-ik10-wsense-dahua.jpg",
    type: "PTZ",
    megapixels: 4,
    lensMotorized: "4.8-154mm",
    lensType: "Motorizada",
    irRange: 150,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: true,
    hasPOE: false,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-66462",
    brand: "DAHUA",
    model: "IPC-HDW5241TMP-AS",
    fullName: "Dome IPC-HDW5241TMP-AS 2MP 2.8mm IR50M ePoE WMIND DAHUA",
    ref: "VDDH-66462",
    price: "101,15 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11389-dome-ipc-hdw5241tmp-as-2mp-28mm-ir50m-epoe-wmind-dahua-6939554968853.html",
    image: "https://conteragroup.pt/2618-medium_default/dome-ipc-hdw5241tmp-as-2mp-28mm-ir50m-epoe-wmind-dahua.jpg",
    type: "Dome",
    megapixels: 2,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-66449",
    brand: "DAHUA",
    model: "IPC-HDW3441TM-AS-0280B",
    fullName: "Dome IPC-HDW3441TM-AS-0280B IP 4MP 2.8mm IR50M WSENSE",
    ref: "VDDH-66449",
    price: "79,59 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11383-dome-ipc-hdw3441tm-as-0280b-ip-4mp-28mm-ir50m-wsense-6939554975103.html",
    image: "https://conteragroup.pt/2612-medium_default/dome-ipc-hdw3441tm-as-0280b-ip-4mp-28mm-ir50m-wsense.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10451",
    brand: "DAHUA",
    model: "Tubular",
    fullName: "Tubular Térmica TPC-BF1241-B7F8-DW-S2 4MP 7mm IR30M DAHUA",
    ref: "VDDH-10451",
    price: "730,00 €",
    link: "https://conteragroup.pt/camaras-tpc-termicas/11355-tubular-termica-tpc-bf1241-b7f8-dw-s2-4mp-7mm-ir30m-dahua-6923172568311.html",
    image: "https://conteragroup.pt/3059-medium_default/tubular-termica-tpc-bf1241-b7f8-dw-s2-4mp-7mm-ir30m-dahua.jpg",
    type: "Tubular",
    megapixels: 4,
    lensFixed: "8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "DWDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: false,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10236",
    brand: "DAHUA",
    model: "IPC-HFW2531T-ZS-S2",
    fullName: "Tubular IPC-HFW2531T-ZS-S2 5MP MTZ 2.7-13.5mm IR60M IP67",
    ref: "VDDH-10236",
    price: "112,94 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/11238-tubular-ipc-hfw2531t-zs-s2-5mp-mtz-27-135mm-ir60m-ip67-6939554977923.html",
    image: "https://conteragroup.pt/2480-medium_default/tubular-ipc-hfw2531t-zs-s2-5mp-mtz-27-135mm-ir60m-ip67.jpg",
    type: "Tubular",
    megapixels: 5,
    lensMotorized: "2.7-13.5mm",
    lensType: "Motorizada",
    irRange: 60,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10227",
    brand: "DAHUA",
    model: "SD29204UE-GN-W",
    fullName: "PTZ INTERIOR SD29204UE-GN-W IP 2MP WI-FI 4X IR30M STRL DAHUA",
    ref: "VDDH-10227",
    price: "148,84 €",
    link: "https://conteragroup.pt/camaras-ip-speed-domes/11821-ptz-interior-sd29204ue-gn-w-ip-2mp-wi-fi-4x-ir30m-strl-dahua-6939554964213.html",
    image: "https://conteragroup.pt/3054-medium_default/ptz-interior-sd29204ue-gn-w-ip-2mp-wi-fi-4x-ir30m-strl-dahua.jpg",
    type: "PTZ",
    megapixels: 2,
    lensMotorized: "2.7-11mm",
    lensType: "Motorizada",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: true,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: false,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10185",
    brand: "DAHUA",
    model: "IPC-HDBW3441F-AS",
    fullName: "Dome IPC-HDBW3441F-AS 4MP 2.8mm IR30M IK10 WSENSE DAHUA",
    ref: "VDDH-10185",
    price: "203,72 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11212-dome-ipc-hdbw3441f-as-4mp-28mm-ir30m-ik10-wsense-dahua-6923172541765.html",
    image: "https://conteragroup.pt/2454-medium_default/dome-ipc-hdbw3441f-as-4mp-28mm-ir30m-ik10-wsense-dahua.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: true,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10069",
    brand: "DAHUA",
    model: "Tubular",
    fullName: "Tubular Térmica TPC-BF2241-B3F4-DW-S2 4MP 4mm IR35M DAHUA",
    ref: "VDDH-10069",
    price: "1232,79 €",
    link: "https://conteragroup.pt/camaras-tpc-termicas/11156-tubular-termica-tpc-bf2241-b3f4-dw-s2-4mp-4mm-ir35m-dahua-6923172532701.html",
    image: "https://conteragroup.pt/2399-medium_default/tubular-termica-tpc-bf2241-b3f4-dw-s2-4mp-4mm-ir35m-dahua.jpg",
    type: "Tubular",
    megapixels: 4,
    lensFixed: "4mm",
    lensType: "Fixa",
    irRange: 35,
    wdrType: "DWDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: false,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10739",
    brand: "DAHUA",
    model: "IPC-HDW5842TP-ZE-S3",
    fullName: "Dome IPC-HDW5842TP-ZE-S3 8MP MTZ 2.7-12mm IR40M WMIND DAHUA",
    ref: "VDDH-10739",
    price: "0,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/13163-dome-ipc-hdw5842tp-ze-s3-8mp-mtz-27-12mm-ir40m-wmind-dahua-6923172586322.html",
    image: "https://conteragroup.pt/4650-medium_default/dome-ipc-hdw5842tp-ze-s3-8mp-mtz-27-12mm-ir40m-wmind-dahua.jpg",
    type: "Dome",
    megapixels: 8,
    lensMotorized: "2.7-12mm",
    lensType: "Motorizada",
    irRange: 40,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10814",
    brand: "DAHUA",
    model: "IPC-HFW2541T-ZS",
    fullName: "Tubular IPC-HFW2541T-ZS PRETA 5MP MTZ 2.7-13.5mm IR60 WSENSE",
    ref: "VDDH-10814",
    price: "266,00 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/13386-tubular-ipc-hfw2541t-zs-preta-5mp-mtz-27-135mm-ir60-wsense-6923172558749.html",
    image: "https://conteragroup.pt/5017-medium_default/tubular-ipc-hfw2541t-zs-preta-5mp-mtz-27-135mm-ir60-wsense.jpg",
    type: "Tubular",
    megapixels: 5,
    lensMotorized: "2.7-13.5mm",
    lensType: "Motorizada",
    irRange: 60,
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-00737",
    brand: "DAHUA",
    model: "Tubular",
    fullName: "Tubular Térmica TPC-BF1241-D3F4-WIFI 4MP 4mm IR30M WSENSE",
    ref: "VDDH-00737",
    price: "970,24 €",
    link: "https://conteragroup.pt/camaras-tpc-termicas/10959-tubular-termica-tpc-bf1241-d3f4-wifi-4mp-4mm-ir30m-wsense-6939554923265.html",
    image: "https://conteragroup.pt/2202-medium_default/tubular-termica-tpc-bf1241-d3f4-wifi-4mp-4mm-ir30m-wsense.jpg",
    type: "Tubular",
    megapixels: 4,
    lensFixed: "4mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "DWDR",
    hasWifi: true,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: false,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-00733",
    brand: "DAHUA",
    model: "IPC-HFW5541T-AS-PV",
    fullName: "Tubular IPC-HFW5541T-AS-PV 5MP 2.8mm IR60M WMIND DAHUA",
    ref: "VDDH-00733",
    price: "335,45 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/10957-tubular-ipc-hfw5541t-as-pv-5mp-28mm-ir60m-ip67-wmind-dahua-6939554966958.html",
    image: "https://conteragroup.pt/2975-medium_default/tubular-ipc-hfw5541t-as-pv-5mp-28mm-ir60m-ip67-wmind-dahua.jpg",
    type: "Tubular",
    megapixels: 5,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 60,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-00712",
    brand: "DAHUA",
    model: "IPC-HFW2231T-ZS-B",
    fullName: "Tubular IPC-HFW2231T-ZS-B PRETA IP 2MP Mtz. 2.7-13.5mm DAHUA",
    ref: "VDDH-00712",
    price: "201,39 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/10943-tubular-ipc-hfw2231t-zs-b-preta-ip-2mp-mtz-27-135mm-dahua-5600341676893.html",
    image: "https://conteragroup.pt/2972-medium_default/tubular-ipc-hfw2231t-zs-b-preta-ip-2mp-mtz-27-135mm-dahua.jpg",
    type: "Tubular",
    megapixels: 2,
    lensMotorized: "2.7-13.5mm",
    lensType: "Motorizada",
    irRange: 60,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10519",
    brand: "DAHUA",
    model: "SD4A216DB-HNY",
    fullName: "PTZ SD4A216DB-HNY IP 2MP 16X IR100M TRCK WSENSE DAHUA",
    ref: "VDDH-10519",
    price: "237,15 €",
    link: "https://conteragroup.pt/camaras-ip-speed-domes/11550-ptz-sd4a216db-hny-ip-2mp-580mm-16x-ir100m-ip66-wsense.html",
    image: "https://conteragroup.pt/3066-medium_default/ptz-sd4a216db-hny-ip-2mp-580mm-16x-ir100m-ip66-wsense.jpg",
    type: "PTZ",
    megapixels: 2,
    lensMotorized: "5-80mm",
    lensType: "Motorizada",
    irRange: 100,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: false,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10267",
    brand: "DAHUA",
    model: "IPC-HDBW3541F-AS-M",
    fullName: "Dome IPC-HDBW3541F-AS-M 5MP 2.8mm IR30M IK10 WSENSE DAHUA",
    ref: "VDDH-10267",
    price: "94,35 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11250-dome-ipc-hdbw3541f-as-m-5mp-28mm-ir30m-ip67-ik10-wsense-6939554975394.html",
    image: "https://conteragroup.pt/2492-medium_default/dome-ipc-hdbw3541f-as-m-5mp-28mm-ir30m-ip67-ik10-wsense.jpg",
    type: "Dome",
    megapixels: 5,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: true,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10535",
    brand: "DAHUA",
    model: "IPC-HFW3549T1-AS-PV-S5",
    fullName: "Tubular IPC-HFW3549T1-AS-PV-S5 5MP 2.8mm IR30M AcuPick TIOC",
    ref: "VDDH-10535",
    price: "426,00 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/11616-tubular-ipc-hfw3549t1-as-pv-s5-5mp-28mm-ir30m-acupick.html",
    image: "https://conteragroup.pt/3044-medium_default/tubular-ipc-hfw3549t1-as-pv-s5-5mp-28mm-ir30m-acupick.jpg",
    type: "Tubular",
    megapixels: 5,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10335",
    brand: "DAHUA",
    model: "Pan",
    fullName: "Pan & Tilt TPC-PT8441D TÉRMICA IP 4MP 6-33mm 19x IR150M IP66",
    ref: "VDDH-10335",
    price: "22875,67 €",
    link: "https://conteragroup.pt/camaras-tpc-termicas/12009-pan-tilt-tpc-pt8441d-termica-ip-4mp-6-33mm-19x-ir150m-ip66.html",
    image: "https://conteragroup.pt/3555-medium_default/pan-tilt-tpc-pt8441d-termica-ip-4mp-6-33mm-19x-ir150m-ip66.jpg",
    type: "Dome",
    megapixels: 4,
    lensMotorized: "6-33mm",
    lensType: "Motorizada",
    irRange: 150,
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: false,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10282",
    brand: "DAHUA",
    model: "IPC-HFW5442H-ZHE",
    fullName: "Tubular IPC-HFW5442H-ZHE 4MP MTZ 2.7-12mm IR60M POE WMIND",
    ref: "VDDH-10282",
    price: "645,00 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/11784-tubular-ipc-hfw5442h-zhe-4mp-mtz-27-12mm-ir60m-poe-wmind-6939554992308.html",
    image: "https://conteragroup.pt/3037-medium_default/tubular-ipc-hfw5442h-zhe-4mp-mtz-27-12mm-ir60m-poe-wmind.jpg",
    type: "Tubular",
    megapixels: 4,
    lensMotorized: "2.7-12mm",
    lensType: "Motorizada",
    irRange: 60,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-66463",
    brand: "DAHUA",
    model: "IPC-HFW5241TP-AS-LED",
    fullName: "Tubular IPC-HFW5241TP-AS-LED 2MP 2.8mm IR25M IK10 WMIND",
    ref: "VDDH-66463",
    price: "89,13 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/11887-tubular-ipc-hfw5241tp-as-led-2mp-28mm-ir25m-ik10-wmind-6939554967252.html",
    image: "https://conteragroup.pt/3048-medium_default/tubular-ipc-hfw5241tp-as-led-2mp-28mm-ir25m-ik10-wmind.jpg",
    type: "Tubular",
    megapixels: 2,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 25,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: true,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10565",
    brand: "DAHUA",
    model: "Dome",
    fullName: "Dome Térmica TPC-DF1241-B3F4-DW-S2 IP 4MP 3.5mm PoE WSENSE",
    ref: "VDDH-10565",
    price: "716,00 €",
    link: "https://conteragroup.pt/camaras-tpc-termicas/11879-dome-termica-tpc-df1241-b3f4-dw-s2-ip-4mp-35mm-poe-wsense-6923172568281.html",
    image: "https://conteragroup.pt/3070-medium_default/dome-termica-tpc-df1241-b3f4-dw-s2-ip-4mp-35mm-poe-wsense.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "3.5mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "DWDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10285",
    brand: "DAHUA",
    model: "SD22404T-GN-W",
    fullName: "Dome PTZ SD22404T-GN-W IP 4MP 4x 2.7-11mm WI-FI IK10 DAHUA",
    ref: "VDDH-10285",
    price: "140,96 €",
    link: "https://conteragroup.pt/camaras-ip-speed-domes/11826-dome-ptz-sd22404t-gn-w-ip-4mp-4x-27-11mm-wi-fi-ik10-dahua-6939554942464.html",
    image: "https://conteragroup.pt/3057-medium_default/dome-ptz-sd22404t-gn-w-ip-4mp-4x-27-11mm-wi-fi-ik10-dahua.jpg",
    type: "PTZ",
    megapixels: 4,
    lensMotorized: "2.7-11mm",
    lensType: "Motorizada",
    irRange: 0,
    wdrType: "WDR",
    hasWifi: true,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: true,
    hasPOE: false,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10403",
    brand: "DAHUA",
    model: "SD4A425DB-HNY",
    fullName: "PTZ SD4A425DB-HNY IP 4MP 25x IR100 (S/SUPORTE) TRCK WSENSE",
    ref: "VDDH-10403",
    price: "307,70 €",
    link: "https://conteragroup.pt/camaras-ip-speed-domes/11832-ptz-sd4a425db-hny-ip-4mp-25x-ir100m-strl-wsense-dahua-6923169706207.html",
    image: "https://conteragroup.pt/3058-medium_default/ptz-sd4a425db-hny-ip-4mp-25x-ir100m-strl-wsense-dahua.jpg",
    type: "PTZ",
    megapixels: 4,
    lensMotorized: "5-125mm",
    lensType: "Motorizada",
    irRange: 100,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: false,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10501",
    brand: "DAHUA",
    model: "SD50225DB-HNY",
    fullName: "PTZ SD50225DB-HNY IP 2MP 25X (SEM IR) IK10 WSENSE DAHUA",
    ref: "VDDH-10501",
    price: "330,65 €",
    link: "https://conteragroup.pt/camaras-ip-speed-domes/11852-ptz-sd50225db-hny-ip-2mp-48-12mm-25x-ip67-ik10-wsense-dahua-6923172547859.html",
    image: "https://conteragroup.pt/4439-medium_default/ptz-sd50225db-hny-ip-2mp-48-12mm-25x-ip67-ik10-wsense-dahua.jpg",
    type: "PTZ",
    megapixels: 2,
    lensMotorized: "4.8-12mm",
    lensType: "Motorizada",
    irRange: 0,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: true,
    hasPOE: false,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10506",
    brand: "DAHUA",
    model: "IPC-PDW3849-A180-AS-PV",
    fullName: "Dome IPC-PDW3849-A180-AS-PV 8MP 2x4MP 2.8 180° IR25 TIOC",
    ref: "VDDH-10506",
    price: "498,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11554-dome-ipc-pdw3849-a180-as-pv-8mp-2x4mp-28mm-180o-ip67-poe-6923172593191.html",
    image: "https://conteragroup.pt/2947-medium_default/dome-ipc-pdw3849-a180-as-pv-8mp-2x4mp-28mm-180o-ip67-poe.jpg",
    type: "Dome",
    megapixels: 8,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 25,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10509",
    brand: "DAHUA",
    model: "IPC-HFW2541S-S",
    fullName: "Tubular IPC-HFW2541S-S 5MP 2.8mm IR30M WDR WSENSE DAHUA",
    ref: "VDDH-10509",
    price: "77,35 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/11809-tubular-ipc-hfw2541s-s-5mp-28mm-ir30m-wdr-wsense-dahua-6923172581303.html",
    type: "Tubular",
    megapixels: 5,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10808",
    brand: "DAHUA",
    model: "IPC-HDBW5442T-ZE-B",
    fullName: "Dome IPC-HDBW5442T-ZE-B 4MP MTZ 2.7-12mm IR40M PoE AI PRETA",
    ref: "VDDH-10808",
    price: "211,65 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/13376-dome-ipc-hdbw5442e-ze-b-4mp-mtz-27-12mm-ir40m-poe-ai-preta.html",
    image: "https://conteragroup.pt/4883-medium_default/dome-ipc-hdbw5442e-ze-b-4mp-mtz-27-12mm-ir40m-poe-ai-preta.jpg",
    type: "Dome",
    megapixels: 4,
    lensMotorized: "2.7-12mm",
    lensType: "Motorizada",
    irRange: 40,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10040",
    brand: "DAHUA",
    model: "IPC-HDW2231TM-AS-S2-QH",
    fullName: "Dome IPC-HDW2231TM-AS-S2-QH 2MP 2.8mm WDR STRL IR30M DAHUA",
    ref: "VDDH-10040",
    price: "55,53 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11132-dome-ipc-hdw2231tm-as-s2-qh-2mp-28mm-wdr-strl-ir30m-dahua-6923172520180.html",
    image: "https://conteragroup.pt/2375-medium_default/dome-ipc-hdw2231tm-as-s2-qh-2mp-28mm-wdr-strl-ir30m-dahua.jpg",
    type: "Dome",
    megapixels: 2,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "DWDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-00817",
    brand: "DAHUA",
    model: "NKB5000-F",
    fullName: "NKB5000-F - MESA CONTROLO 10.1\" P/PTZ REDE HD DAHUA",
    ref: "VDDH-00817",
    price: "991,57 €",
    link: "https://conteragroup.pt/camaras-ip-speed-domes/11010-nkb5000-f---teclado-controlo-rede-hd-para-ptz-dahua-6939554916595.html",
    type: "PTZ",
    megapixels: 0,
    lensType: "Fixa",
    irRange: 0,
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: false,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-00744",
    brand: "DAHUA",
    model: "IPC-HFW3841T-ZS",
    fullName: "Tubular IPC-HFW3841T-ZS IP 8MP Mtz 2.7-13mm IR60M WSENSE",
    ref: "VDDH-00744",
    price: "203,12 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/10961-tubular-ipc-hfw3841t-zs-ip-8mp-mtz-27-13mm-ir60m-wsense-6939554993329.html",
    image: "https://conteragroup.pt/2204-medium_default/tubular-ipc-hfw3841t-zs-ip-8mp-mtz-27-13mm-ir60m-wsense.jpg",
    type: "Tubular",
    megapixels: 8,
    lensMotorized: "2.7-13mm",
    lensType: "Motorizada",
    irRange: 60,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10777",
    brand: "DAHUA",
    model: "EPT9A1825-HNR-GA",
    fullName: "EPT9A1825-HNR-GA - CÂMARA ANTI-EXPLOSÃO 8MP 25X IR100M IP68",
    ref: "VDDH-10777",
    price: "18979,20 €",
    link: "https://conteragroup.pt/camaras-ip-speed-domes/13479-ept9a1825-hnr-ga-camara-anti-explosao-8mp-25x-ir100m-ip68-6939554972041.html",
    image: "https://conteragroup.pt/4970-medium_default/ept9a1825-hnr-ga-camara-anti-explosao-8mp-25x-ir100m-ip68.jpg",
    type: "Dome",
    megapixels: 8,
    lensMotorized: "5.4-135mm",
    lensType: "Motorizada",
    irRange: 100,
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: false,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10500",
    brand: "DAHUA",
    model: "SD5A225GB-HNR-SL",
    fullName: "PTZ SD5A225GB-HNR-SL IP 2MP ANTI-CORROSÃO 25x IR150M WSENSE",
    ref: "VDDH-10500",
    price: "538,05 €",
    link: "https://conteragroup.pt/camaras-ip-speed-domes/11851-ptz-sd5a225gb-hnr-sl-ip-2mp-anti-corrosao-25x-ir150m-wsense-6923172536761.html",
    image: "https://conteragroup.pt/3063-medium_default/ptz-sd5a225gb-hnr-sl-ip-2mp-anti-corrosao-25x-ir150m-wsense.jpg",
    type: "PTZ",
    megapixels: 2,
    lensMotorized: "4.8-120mm",
    lensType: "Motorizada",
    irRange: 150,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: false,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-00674",
    brand: "DAHUA",
    model: "IPC-HDW5442T-ZE-S3",
    fullName: "Dome IPC-HDW5442T-ZE-S3 4MP Mtrz 2.7-12mm IR40M WMIND DAHUA",
    ref: "VDDH-00674",
    price: "190,86 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/10923-dome-ipc-hdw5442t-ze-4mp-mtrz-27-12mm-ir40m-wmind-dahua-6939554991578.html",
    image: "https://conteragroup.pt/2967-medium_default/dome-ipc-hdw5442t-ze-4mp-mtrz-27-12mm-ir40m-wmind-dahua.jpg",
    type: "Dome",
    megapixels: 4,
    lensMotorized: "2.7-12mm",
    lensType: "Motorizada",
    irRange: 40,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10788",
    brand: "DAHUA",
    model: "IPC-HFW5459E1-ZE-IL",
    fullName: "Tubular IPC-HFW5459E1-ZE-IL 4MP 2.7-12mm IR60 WMIND IK10",
    ref: "VDDH-10788",
    price: "576,00 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/13490-tubular-ipc-hfw5459e1-ze-il-4mp-mtz-27-12mm-ir60m-wmind.html",
    image: "https://conteragroup.pt/4981-medium_default/tubular-ipc-hfw5459e1-ze-il-4mp-mtz-27-12mm-ir60m-wmind.jpg",
    type: "Tubular",
    megapixels: 4,
    lensMotorized: "2.7-12mm",
    lensType: "Motorizada",
    irRange: 60,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: true,
    hasAI: true,
    hasIK10: true,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-00690",
    brand: "DAHUA",
    model: "IPC-HDBW5442E-Z4E",
    fullName: "Dome IPC-HDBW5442E-Z4E 4MP Mtrz 8-32mm IR80M WMIND DAHUA",
    ref: "VDDH-00690",
    price: "277,10 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/10933-dome-ipc-hdbw5442e-z4e-4mp-mtrz-8-32mm-ir80m-wmind-dahua-6939554972508.html",
    image: "https://conteragroup.pt/2936-medium_default/dome-ipc-hdbw5442e-z4e-4mp-mtrz-8-32mm-ir80m-wmind-dahua.jpg",
    type: "Dome",
    megapixels: 4,
    lensMotorized: "8-32mm",
    lensType: "Motorizada",
    irRange: 80,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10554",
    brand: "DAHUA",
    model: "IPC-HFW2541S-S-S2",
    fullName: "Tubular IPC-HFW2541S-S-S2 5MP 2.8mm IR30M WDR WSENSE DAHUA",
    ref: "VDDH-10554",
    price: "185,00 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/12014-tubular-ipc-hfw2541s-s-s2-5mp-28mm-ir30m-wdr-wsense-dahua-6923172581303.html",
    image: "https://conteragroup.pt/3553-medium_default/tubular-ipc-hfw2541s-s-s2-5mp-28mm-ir30m-wdr-wsense-dahua.jpg",
    type: "Tubular",
    megapixels: 5,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-00631",
    brand: "DAHUA",
    model: "SD49225XA-HNR",
    fullName: "PTZ SD49225XA-HNR IP 2MP 25x IR100M WDR STRL WSENSE DAHUA",
    ref: "VDDH-00631",
    price: "298,86 €",
    link: "https://conteragroup.pt/camaras-ip-speed-domes/10900-ptz-sd49225xa-hnr-ip-2mp-25x-ir100m-wdr-strl-wsense-dahua-6939554979446.html",
    image: "https://conteragroup.pt/2143-medium_default/ptz-sd49225xa-hnr-ip-2mp-25x-ir100m-wdr-strl-wsense-dahua.jpg",
    type: "PTZ",
    megapixels: 2,
    lensMotorized: "4.8-120mm",
    lensType: "Motorizada",
    irRange: 100,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: false,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10811",
    brand: "DAHUA",
    model: "IPC-HFW5559T-ASE-IL",
    fullName: "Tubular IPC-HFW5559T-ASE-IL 5MP 2.8mm IR50M IK10 WMIND DAHUA",
    ref: "VDDH-10811",
    price: "140,25 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/13509-tubular-ipc-hfw5559t-ase-il-5mp-28mm-ir80m-ik10-wmind-dahua.html",
    image: "https://conteragroup.pt/5006-medium_default/tubular-ipc-hfw5559t-ase-il-5mp-28mm-ir80m-ik10-wmind-dahua.jpg",
    type: "Tubular",
    megapixels: 5,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 80,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: true,
    hasAI: true,
    hasIK10: true,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-00616",
    brand: "DAHUA",
    model: "IPC-HDBW2831EP-S-S2",
    fullName: "Dome IPC-HDBW2831EP-S-S2 IP 8MP-4K 2.8mm IR30M IK10 DAHUA",
    ref: "VDDH-00616",
    price: "118,96 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/10886-dome-ipc-hdbw2831ep-s-s2-ip-8mp-4k-28mm-ir30m-ik10-dahua-6939554980862.html",
    type: "Dome",
    megapixels: 8,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: true,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10639",
    brand: "DAHUA",
    model: "IPC-HFW3449T1-ZAS-PV-B",
    fullName: "Tubular IPC-HFW3449T1-ZAS-PV-B PRETA 4MP MTZ IR50M TIOC 2",
    ref: "VDDH-10639",
    price: "428,00 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/13551-tubular-ipc-hfw3449t1-zas-pv-b-preta-4mp-mtz-ir50m-tioc-2-6939554994296.html",
    type: "Tubular",
    megapixels: 4,
    lensMotorized: "2.7-13.5mm",
    lensType: "Motorizada",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10830",
    brand: "DAHUA",
    model: "IPC-HDW1539DA-SW-PV",
    fullName: "Dome IPC-HDW1539DA-SW-PV 5MP 2.8mm WIFI IR30M DUAL DAHUA",
    ref: "VDDH-10830",
    price: "106,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/13553-dome-ipc-hdw1539da-sw-pv-5mp-28mm-wifi-ir30m-dual-dahua-6939554908699.html",
    type: "Dome",
    megapixels: 5,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "DWDR",
    hasWifi: true,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: false,
    hasIK10: false,
    hasPOE: false,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-00191",
    brand: "DAHUA",
    model: "IPC-HFW2231T-ZS",
    fullName: "Tubular IPC-HFW2231T-ZS IP 2MP Mtz 2.7-13.5mm IR60M DAHUA",
    ref: "VDDH-00191",
    price: "85,59 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/10784-tubular-ipc-hfw2231t-zs-ip-2mp-mtz-27-135mm-ir60m-dahua-6939554974632.html",
    image: "https://conteragroup.pt/2027-medium_default/tubular-ipc-hfw2231t-zs-ip-2mp-mtz-27-135mm-ir60m-dahua.jpg",
    type: "Tubular",
    megapixels: 2,
    lensMotorized: "2.7-13.5mm",
    lensType: "Motorizada",
    irRange: 60,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10834",
    brand: "DAHUA",
    model: "IPC-HDBW7859Z-Z-PV-X",
    fullName: "PTRZ Dome IPC-HDBW7859Z-Z-PV-X 8MP MTZ 2.7-12mm IR60M IK10",
    ref: "VDDH-10834",
    price: "1507,90 €",
    link: "https://conteragroup.pt/camaras-ip-speed-domes/13571-ptrz-dome-ipc-hdbw7859z-z-pv-x-8mp-mtz-27-12mm-ir60m-ik10.html",
    image: "https://conteragroup.pt/5084-medium_default/ptrz-dome-ipc-hdbw7859z-z-pv-x-8mp-mtz-27-12mm-ir60m-ik10.jpg",
    type: "PTRZ",
    megapixels: 8,
    lensMotorized: "2.7-12mm",
    lensType: "Motorizada",
    irRange: 60,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: false,
    hasIK10: true,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10853",
    brand: "DAHUA",
    model: "IPC-HDW5459TM-ASE-IL",
    fullName: "IPC-HDW5459TM-ASE-IL 4mp DOME 2.8m XINGHAM IR/ LUZ BRANCA",
    ref: "VDDH-10853",
    price: "362,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/13873-ipc-hdw5459tm-ase-il-4mp-dome-28m-xingham-ir-luz-branca.html",
    image: "https://conteragroup.pt/5337-medium_default/ipc-hdw5459tm-ase-il-4mp-dome-28m-xingham-ir-luz-branca.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10065",
    brand: "DAHUA",
    model: "IPC-HFW3449T1-ZAS-PV",
    fullName: "Tubular IPC-HFW3449T1-ZAS-PV 4MP Mtz 2.7-13.5 IR50M TIOC 2.0",
    ref: "VDDH-10065",
    price: "181,90 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/11152-tubular-ipc-hfw3449t1-zas-pv-4mp-mtz-27-135-ir50m-tioc-20-6923172502704.html",
    image: "https://conteragroup.pt/2395-medium_default/tubular-ipc-hfw3449t1-zas-pv-4mp-mtz-27-135-ir50m-tioc-20.jpg",
    type: "Tubular",
    megapixels: 4,
    lensMotorized: "2.7-13.5mm",
    lensType: "Motorizada",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10737",
    brand: "DAHUA",
    model: "IPC-HFW7842H-Z-X",
    fullName: "Tubular IPC-HFW7842H-Z-X 8MP MTZ 2.7-12mm IR60M IK10 WMIND",
    ref: "VDDH-10737",
    price: "1385,79 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/13162-tubular-ipc-hfw7842h-z-x-8mp-mtz-27-12mm-ir60m-ik10-wmind.html",
    image: "https://conteragroup.pt/4649-medium_default/tubular-ipc-hfw7842h-z-x-8mp-mtz-27-12mm-ir60m-ik10-wmind.jpg",
    type: "Tubular",
    megapixels: 8,
    lensMotorized: "2.7-12mm",
    lensType: "Motorizada",
    irRange: 60,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: true,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10531",
    brand: "DAHUA",
    model: "IPC-HFW3449T1-AS-PV-S5",
    fullName: "Tubular IPC-HFW3449T1-AS-PV-S5 4MP 2.8mm IR30M AcuPick TiOC",
    ref: "VDDH-10531",
    price: "390,00 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/11612-tubular-ipc-hfw3449t1-as-pv-s5-4mp-28mm-ir30m-acupick-tioc-6923172525680.html",
    image: "https://conteragroup.pt/3043-medium_default/tubular-ipc-hfw3449t1-as-pv-s5-4mp-28mm-ir30m-acupick-tioc.jpg",
    type: "Tubular",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10721",
    brand: "DAHUA",
    model: "IPC-HFW2449TL-S-PRO",
    fullName: "Tubular IPC-HFW2449TL-S-PRO 4MP 2.8mm IR50M WIZCOLOR DAHUA",
    ref: "VDDH-10721",
    price: "178,00 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/13034-tubular-ipc-hfw2449tl-s-pro-4mp-28mm-ir50m-wizcolor-tioc-6937552417786.html",
    image: "https://conteragroup.pt/4453-medium_default/tubular-ipc-hfw2449tl-s-pro-4mp-28mm-ir50m-wizcolor-tioc.jpg",
    type: "Tubular",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10674",
    brand: "DAHUA",
    model: "IPC-HDBW5842E-ZE-S3",
    fullName: "Dome IPC-HDBW5842E-ZE-S3 8MP MTZ 2.7-12mm IR40M IK10 WMIND",
    ref: "VDDH-10674",
    price: "308,13 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/12613-dome-ipc-hdbw5842e-ze-s3-8mp-mtz-27-12mm-ir40m-ik10-wmind-6923172587558.html",
    image: "https://conteragroup.pt/3958-medium_default/dome-ipc-hdbw5842e-ze-s3-8mp-mtz-27-12mm-ir40m-ik10-wmind.jpg",
    type: "Dome",
    megapixels: 8,
    lensMotorized: "2.7-12mm",
    lensType: "Motorizada",
    irRange: 40,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: true,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10457",
    brand: "DAHUA",
    model: "IPC-HDW2541T-S-S2",
    fullName: "Dome IPC-HDW2541T-S-S2 5MP 2.8mm IR30M WSENSE DAHUA",
    ref: "VDDH-10457",
    price: "190,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11359-dome-ipc-hdw2541t-s-s2-5mp-28mm-ir30m-wsense-dahua-6923172581259.html",
    image: "https://conteragroup.pt/2593-medium_default/dome-ipc-hdw2541t-s-s2-5mp-28mm-ir30m-wsense-dahua.jpg",
    type: "Dome",
    megapixels: 5,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10541",
    brand: "DAHUA",
    model: "ITC416-PL8I-IZ",
    fullName: "ITC416-PL8I-IZ - Câmara Acesso ANPR 4MP MTZ 2.7–12 mm IR20M",
    ref: "VDDH-10541",
    price: "639,20 €",
    link: "https://conteragroup.pt/camaras-anpr/11622-itc416-pl8i-iz-camara-acesso-anpr-4mp-mtz-2712-mm-ir20m.html",
    image: "https://conteragroup.pt/3069-medium_default/itc416-pl8i-iz-camara-acesso-anpr-4mp-mtz-2712-mm-ir20m.jpg",
    type: "Dome",
    megapixels: 4,
    lensMotorized: "2.7-12mm",
    lensType: "Motorizada",
    irRange: 20,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: false,
    detPeople: false,
    detVehicle: false,
    hasLPR: true,
  },
  {
    id: "dahua-VDDH-10399",
    brand: "DAHUA",
    model: "IPC-HDBW2241R-ZS",
    fullName: "Dome IPC-HDBW2241R-ZS 2MP MTZ 2.7-13.5mm IR40M IK10 WSENSE",
    ref: "VDDH-10399",
    price: "220,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11330-dome-ipc-hdbw2241r-zs-2mp-mtz-27-135mm-ir40m-ik10-wsense-6923172545695.html",
    image: "https://conteragroup.pt/2569-medium_default/dome-ipc-hdbw2241r-zs-2mp-mtz-27-135mm-ir40m-ik10-wsense.jpg",
    type: "Dome",
    megapixels: 2,
    lensMotorized: "2.7-13.5mm",
    lensType: "Motorizada",
    irRange: 40,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: true,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10706",
    brand: "DAHUA",
    model: "SDT8C842-8P-FA-APV",
    fullName: "PTZ SDT8C842-8P-FA-APV 8MP 2.8mm 42x PANORÂMICA IR300M WMIND",
    ref: "VDDH-10706",
    price: "1 668,96 €",
    link: "https://conteragroup.pt/camaras-ip-speed-domes/12978-ptz-sdt8c842-8p-fa-apv-8mp-28mm-42x-panoramica-ir300m-wmind.html",
    image: "https://conteragroup.pt/4386-medium_default/ptz-sdt8c842-8p-fa-apv-8mp-28mm-42x-panoramica-ir300m-wmind.jpg",
    type: "PTZ",
    megapixels: 8,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 300,
    wdrType: "DWDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: false,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10708",
    brand: "DAHUA",
    model: "IPC-HDW3849H-AS-PV-PRO",
    fullName: "Dome IPC-HDW3849H-AS-PV-PRO 8MP 2.8mm IR30M TIOC PRO DAHUA",
    ref: "VDDH-10708",
    price: "474,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/12980-dome-ipc-hdw3849h-as-pv-pro-8mp-28mm-ir30m-pro-tioc-dahua-6939554974618.html",
    type: "Dome",
    megapixels: 8,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10397",
    brand: "DAHUA",
    model: "SD22404DB-GNY",
    fullName: "DOME PTZ SD22404DB-GNY IP 4MP 2.8-12mm 4x STRL IK10 WSENSE",
    ref: "VDDH-10397",
    price: "128,35 €",
    link: "https://conteragroup.pt/camaras-ip-speed-domes/11328-dome-ptz-sd22404db-gny-ip-4mp-28-12mm-4x-strl-ik10-wsense-6923172536334.html",
    image: "https://conteragroup.pt/2567-medium_default/dome-ptz-sd22404db-gny-ip-4mp-28-12mm-4x-strl-ik10-wsense.jpg",
    type: "PTZ",
    megapixels: 4,
    lensMotorized: "2.8-12mm",
    lensType: "Motorizada",
    irRange: 0,
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: true,
    hasPOE: false,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10357",
    brand: "DAHUA",
    model: "IPC-HDBW3841E-S-S2",
    fullName: "Dome IPC-HDBW3841E-S-S2 8MP 2.8mm IR30M IK10 WSENSE DAHUA",
    ref: "VDDH-10357",
    price: "151,37 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11304-dome-ipc-hdbw3841e-s-s2-8mp-28mm-ir30m-ik10-wsense-dahua-6923172541727.html",
    type: "Dome",
    megapixels: 8,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: true,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10287",
    brand: "DAHUA",
    model: "IPC-HFW3441E-AS-S2",
    fullName: "Tubular IPC-HFW3441E-AS-S2 4MP 2.8mm IR50M WSENSE DAHUA",
    ref: "VDDH-10287",
    price: "86,67 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/11261-tubular-ipc-hfw3441e-as-s2-4mp-28mm-ir50m-wsense-dahua-6923172542045.html",
    type: "Tubular",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10719",
    brand: "DAHUA",
    model: "IPC-HDW3449H-AS-PV-PRO-B",
    fullName: "Dome IPC-HDW3449H-AS-PV-PRO-B PRETA 4MP 2.8mm IR30M WIZCOLOR",
    ref: "VDDH-10719",
    price: "360,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/13032-dome-ipc-hdw3449h-as-pv-pro-b-4mp-28mm-ir30m-preta-wizcolor-6939554948374.html",
    image: "https://conteragroup.pt/4451-medium_default/dome-ipc-hdw3449h-as-pv-pro-b-4mp-28mm-ir30m-preta-wizcolor.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10720",
    brand: "DAHUA",
    model: "IPC-HDW2449T-S-PRO",
    fullName: "Dome IPC-HDW2449T-S-PRO 4MP 2.8mm IR30M WIZCOLOR DAHUA",
    ref: "VDDH-10720",
    price: "178,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/13033-dome-ipc-hdw2449t-s-pro-4mp-28mm-ir30m-wizcolor-tioc-6937552417816.html",
    image: "https://conteragroup.pt/4452-medium_default/dome-ipc-hdw2449t-s-pro-4mp-28mm-ir30m-wizcolor-tioc.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10228",
    brand: "DAHUA",
    model: "SD5A232GB-HNR",
    fullName: "PTZ SD5A232GB-HNR IP 2MP 32x IR150M TRCK IK10 WSENSE DAHUA",
    ref: "VDDH-10228",
    price: "504,05 €",
    link: "https://conteragroup.pt/camaras-ip-speed-domes/11822-ptz-sd5a232gb-hnr-ip-2mp-32x-ir150m-strl-ik10-wsense-dahua-6923172585202.html",
    image: "https://conteragroup.pt/3055-medium_default/ptz-sd5a232gb-hnr-ip-2mp-32x-ir150m-strl-ik10-wsense-dahua.jpg",
    type: "PTZ",
    megapixels: 2,
    lensMotorized: "4.5-144mm",
    lensType: "Motorizada",
    irRange: 150,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: true,
    hasPOE: false,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10736",
    brand: "DAHUA",
    model: "IPC-HDW1539DA-SAW-IL",
    fullName: "Dome IPC-HDW1539DA-SAW-IL 5MP 2.8mm WIFI IR30M DUAL DAHUA",
    ref: "VDDH-10736",
    price: "94,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/13161-dome-ipc-hdw1539da-saw-il-5mp-28mm-ir30m-wifi-ip67-dahua-6923172595607.html",
    image: "https://conteragroup.pt/4648-medium_default/dome-ipc-hdw1539da-saw-il-5mp-28mm-ir30m-wifi-ip67-dahua.jpg",
    type: "Dome",
    megapixels: 5,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "DWDR",
    hasWifi: true,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: true,
    hasAI: false,
    hasIK10: false,
    hasPOE: false,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10286",
    brand: "DAHUA",
    model: "IPC-HFW3441T-ZAS-S2",
    fullName: "Tubular IPC-HFW3441T-ZAS-S2 4MP Mtz 2.7-13.5mm IR60M DAHUA",
    ref: "VDDH-10286",
    price: "309,01 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/11785-tubular-ipc-hfw3441t-zas-s2-4mp-mtz-27-135mm-ir60m-dahua-6923172542441.html",
    image: "https://conteragroup.pt/3038-medium_default/tubular-ipc-hfw3441t-zas-s2-4mp-mtz-27-135mm-ir60m-dahua.jpg",
    type: "Tubular",
    megapixels: 4,
    lensMotorized: "2.7-13.5mm",
    lensType: "Motorizada",
    irRange: 60,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10311",
    brand: "DAHUA",
    model: "IPC-HDBW5441F-AS-E2",
    fullName: "Dome Duplo IPC-HDBW5441F-AS-E2 2x 4MP 2.8mm IR30M WMIND DAHU",
    ref: "VDDH-10311",
    price: "245,65 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11786-dome-duplo-ipc-hdbw5441f-as-e2-2x-4mp-28mm-ir30m-wmind-dahu-6923172524287.html",
    image: "https://conteragroup.pt/2948-medium_default/dome-duplo-ipc-hdbw5441f-as-e2-2x-4mp-28mm-ir30m-wmind-dahu.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10607",
    brand: "DAHUA",
    model: "IPC-HDBW7842E1-Z-X",
    fullName: "Dome IPC-HDBW7842E1-Z-X 8MP MTZ 2.7-12mm IR40M IK10 WMIND",
    ref: "VDDH-10607",
    price: "1385,79 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/12067-dome-ipc-hdbw7842e1-z-x-8mp-mtz-27-12mm-ir40m-ik10-wmind.html",
    image: "https://conteragroup.pt/3540-medium_default/dome-ipc-hdbw7842e1-z-x-8mp-mtz-27-12mm-ir40m-ik10-wmind.jpg",
    type: "Dome",
    megapixels: 8,
    lensMotorized: "2.7-12mm",
    lensType: "Motorizada",
    irRange: 40,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: true,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10183",
    brand: "DAHUA",
    model: "IPC-HFW2431T-ZS-S2-B",
    fullName: "Tubular IPC-HFW2431T-ZS-S2-B PRETA IP 4MP Mtz IR60M DAHUA",
    ref: "VDDH-10183",
    price: "100,80 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/11210-tubular-ipc-hfw2431t-zs-s2-b-preta-ip-4mp-mtz-ir60m-dahua-6939554974656.html",
    image: "https://conteragroup.pt/2452-medium_default/tubular-ipc-hfw2431t-zs-s2-b-preta-ip-4mp-mtz-ir60m-dahua.jpg",
    type: "Tubular",
    megapixels: 4,
    lensMotorized: "2.7-13.5mm",
    lensType: "Motorizada",
    irRange: 60,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-00124",
    brand: "DAHUA",
    model: "NKB1000-E",
    fullName: "NKB1000-E - MESA CONTROLO PTZ RJ45/RS485/RS422/USA DAHUA",
    ref: "VDDH-00124",
    price: "153,00 €",
    link: "https://conteragroup.pt/camaras-ip-speed-domes/10748-nkb1000---teclado-controlo-rj45rs485rs422usa-ptz-dahua-6939554935619.html",
    image: "https://conteragroup.pt/1991-medium_default/nkb1000---teclado-controlo-rj45rs485rs422usa-ptz-dahua.jpg",
    type: "PTZ",
    megapixels: 0,
    lensType: "Fixa",
    irRange: 0,
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: false,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10467",
    brand: "DAHUA",
    model: "IPC-H4A",
    fullName: "Dome IPC-H4A HERO A1 IP 4MP 3.6mm IR10M WI-FI PAN/TILT DAHUA",
    ref: "VDDH-10467",
    price: "33,00 €",
    link: "https://conteragroup.pt/camaras-de-consumo-/11803-dome-ipc-h4a-imou-4mp-36mm-ir10m-wi-fi-dahua-6939554913983.html",
    image: "https://conteragroup.pt/2953-medium_default/dome-ipc-h4a-imou-4mp-36mm-ir10m-wi-fi-dahua.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "3.6mm",
    lensType: "Fixa",
    irRange: 10,
    wdrType: "DWDR",
    hasWifi: true,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: false,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10578",
    brand: "DAHUA",
    model: "IPC-HDW8441X-3D",
    fullName: "Dome IPC-HDW8441X-3D 4MP 2x2.8mm CONTAGEM PESS. IR20M WMIND",
    ref: "VDDH-10578",
    price: "1107,95 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/12023-dome-ipc-hdw8441x-3d-4mp-2x28mm-contagem-pess-ir20m-wmind.html",
    image: "https://conteragroup.pt/3549-medium_default/dome-ipc-hdw8441x-3d-4mp-2x28mm-contagem-pess-ir20m-wmind.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 20,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10758",
    brand: "DAHUA",
    model: "IPC-HDBW3441F-AS-S2",
    fullName: "Dome IPC-HDBW3441F-AS-S2 4MP 2.8mm IR30M IK10 WSENSE DAHUA",
    ref: "VDDH-10758",
    price: "95,20 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/13141-dome-ipc-hdbw3441f-as-s2-4mp-28mm-ir30m-ik10-wsense-dahua-6923172541765.html",
    image: "https://conteragroup.pt/4628-medium_default/dome-ipc-hdbw3441f-as-s2-4mp-28mm-ir30m-ik10-wsense-dahua.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: true,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10068",
    brand: "DAHUA",
    model: "Tubular",
    fullName: "Tubular Térmica TPC-BF1241-B7F8-DW-S8 4MP 4mm IR35M WSENSE",
    ref: "VDDH-10068",
    price: "730,00 €",
    link: "https://conteragroup.pt/camaras-tpc-termicas/11155-tubular-termica-tpc-bf1241-b3f4-dw-s2-4mp-4mm-ir35m-wsense-6939554923661.html",
    image: "https://conteragroup.pt/2398-medium_default/tubular-termica-tpc-bf1241-b3f4-dw-s2-4mp-4mm-ir35m-wsense.jpg",
    type: "Tubular",
    megapixels: 4,
    lensFixed: "4mm",
    lensType: "Fixa",
    irRange: 35,
    wdrType: "DWDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: false,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10763",
    brand: "DAHUA",
    model: "IPC-HFW3449E-AS-IL",
    fullName: "Tubular IPC-HFW3449E-AS-IL 4MP 3.6mm IR50M DUAL WSENSE",
    ref: "VDDH-10763",
    price: "224,00 €",
    link: "https://conteragroup.pt/camaras-ipc-tubulares/13148-tubular-ipc-hfw3449e-as-il-4mp-36mm-ir50m-dual-wsense.html",
    image: "https://conteragroup.pt/4634-medium_default/tubular-ipc-hfw3449e-as-il-4mp-36mm-ir50m-dual-wsense.jpg",
    type: "Tubular",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 50,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: true,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10855",
    brand: "DAHUA",
    model: "IPC-HDBW3849E-AS-IL",
    fullName: "IPC-HDBW3849E-AS-IL 2.8MM 8MP XINGHAM MIC ALARM IN/OUT IK10",
    ref: "VDDH-10855",
    price: "416,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/13874-ipc-hdbw3849e-as-il-28mm-8mp-xingham-mic-alarm-in-out-ik10.html",
    image: "https://conteragroup.pt/5336-medium_default/ipc-hdbw3849e-as-il-28mm-8mp-xingham-mic-alarm-in-out-ik10.jpg",
    type: "Dome",
    megapixels: 8,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: false,
    hasColorNight: true,
    hasDualLight: true,
    hasAI: false,
    hasIK10: true,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-10579",
    brand: "DAHUA",
    model: "IPC-HDBW5842R-ASE-S3",
    fullName: "Dome IPC-HDBW5842R-ASE-S3 8MP 2.8mm IR50M WMIND DAHUA",
    ref: "VDDH-10579",
    price: "416,00 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/12024-dome-ipc-hdbw5842r-ase-s3-8mp-28mm-ir50m-wmind-dahua-6923172588197.html",
    image: "https://conteragroup.pt/3548-medium_default/dome-ipc-hdbw5842r-ase-s3-8mp-28mm-ir50m-wmind-dahua.jpg",
    type: "Dome",
    megapixels: 8,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 50,
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: false,
    hasSDCard: false,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: true,
    hasIK10: false,
    hasPOE: true,
    detPeople: true,
    detVehicle: true,
    hasLPR: false,
  },
  {
    id: "dahua-VDDH-00821",
    brand: "DAHUA",
    model: "IPC-HDW2431T-AS-S2",
    fullName: "Dome IPC-HDW2431T-AS-S2 4MP 2.8mm IR30M WDR SDC DAHUA",
    ref: "VDDH-00821",
    price: "142,14 €",
    link: "https://conteragroup.pt/camaras-ipc-domes/11012-dome-ipc-hdw2431t-as-s2-4mp-28mm-ir30m-wdr-sdc-dahua-6939554981623.html",
    image: "https://conteragroup.pt/2255-medium_default/dome-ipc-hdw2431t-as-s2-4mp-28mm-ir30m-wdr-sdc-dahua.jpg",
    type: "Dome",
    megapixels: 4,
    lensFixed: "2.8mm",
    lensType: "Fixa",
    irRange: 30,
    wdrType: "WDR",
    hasWifi: false,
    has4G: false,
    hasSolar: false,
    hasAudio: true,
    hasSDCard: true,
    hasColorNight: false,
    hasDualLight: false,
    hasAI: false,
    hasIK10: false,
    hasPOE: true,
    detPeople: false,
    detVehicle: false,
    hasLPR: false,
  },

];

export const megapixelOptions = [2, 4, 5, 6, 8, 12, 16];
export const irRangeOptions = [0, 10, 20, 30, 40, 50, 60, 80, 100, 120, 350];
export const typeOptions: CameraType[] = ["Dome", "Tubular", "Fisheye", "PTZ", "Pinhole", "PTRZ"];
